"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var headLine = function(param) {
    var text = param.text, classes = param.classes, image = param.image, pera = param.pera;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                className: classes,
                children: [
                    image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: image,
                        alt: "headling",
                        className: "mr-1 inline-block h-6 w-6 bg-contain bg-center text-xl"
                    }),
                    text
                ]
            }),
            pera && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "dark:text-jacarta-300 mt-6",
                children: "While we take pride in being the first and largest marketplace and in our robust feature set, we also help our partners succeed with the following..."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (headLine);


/***/ }),

/***/ 846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var Partners = function() {
    var partnerGroup = [
        {
            id: 1,
            link: "https://www.nft-dao.org/",
            logo: "partner_logo_1"
        },
        {
            id: 2,
            link: "https://www.nft-dao.org/",
            logo: "partner_logo_2"
        },
        {
            id: 3,
            link: "https://www.nft-dao.org/",
            logo: "partner_logo_3"
        },
        {
            id: 4,
            link: "https://www.nft-dao.org/",
            logo: "partner_logo_4"
        },
        {
            id: 5,
            link: "https://www.nft-dao.org/",
            logo: "partner_logo_5"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "dark:bg-jacarta-900 ",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-2 py-8 sm:grid-cols-5",
                    children: partnerGroup.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: item.link,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/partners/".concat(item.logo, ".png"),
                                alt: "partner 1"
                            })
                        }, item.id);
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Partners);


/***/ }),

/***/ 1484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home_1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/hero/hero.jsx


var hero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative pb-10 pt-20 md:pt-32 h-1527",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                className: "pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/gradient.jpg",
                    alt: "gradient",
                    className: "h-full w-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                className: "pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/gradient_dark.jpg",
                    alt: "gradient dark",
                    className: "h-full w-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container h-full mx-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid h-full items-center gap-4 md:grid-cols-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-6 flex h-full flex-col items-center justify-center py-10 md:items-start md:py-20 xl:col-span-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-jacarta-700 font-bold font-display mb-6 text-center text-5xl dark:text-white md:text-left lg:text-6xl xl:text-7xl",
                                    children: "Power your game-dev with AI generated pixelart"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "dark:text-jacarta-200 mb-8 text-center text-lg md:text-left",
                                    children: "portraits, backgrounds, sprites, items, ..."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex space-x-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/create",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "bg-accent shadow-accent-volume hover:bg-accent-dark w-36 rounded-full py-3 px-8 text-center font-semibold text-white transition-all",
                                                children: "Create on Web"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/gimp",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "bg-accent shadow-accent-volume hover:bg-accent-dark w-36 rounded-full py-3 px-8 text-center font-semibold text-white transition-all",
                                                children: "Create on Gimp"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-6 xl:col-span-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative text-center md:pl-8 md:text-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/pelgine_collage.png",
                                    alt: "",
                                    className: "hero-img mt-8 inline-block w-72 rotate-[0deg] sm:w-full lg:w-[24rem] xl:w-[35rem]"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var hero_hero = (hero);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(1669);
// EXTERNAL MODULE: ./node_modules/tippy.js/dist/tippy.css
var tippy = __webpack_require__(3372);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(965);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./data/bids_data.js
// import '/images/item_1.jpg' from '/images/item_1.jpg';
var bids_data_bidsData = [
    {
        id: 1,
        image: "/images/products/item_1.jpg",
        title: "ETH Me Outside",
        bid_number: 1.55,
        eth_number: 1.3,
        react_number: 159
    },
    {
        id: 2,
        image: "/images/products/item_2.jpg",
        title: "ETH Me Outside",
        bid_number: 1.55,
        eth_number: 1.3,
        react_number: 159
    },
    {
        id: 3,
        image: "/images/products/item_3.jpg",
        title: "ETH Me Outside",
        bid_number: 1.55,
        eth_number: 1.3,
        react_number: 159
    },
    {
        id: 4,
        image: "/images/products/item_4.jpg",
        title: "ETH Me Outside",
        bid_number: 1.55,
        eth_number: 1.3,
        react_number: 159
    },
    {
        id: 5,
        image: "/images/products/item_5.jpg",
        title: "ETH Me Outside",
        bid_number: 1.55,
        eth_number: 1.3,
        react_number: 159
    },
    {
        id: 6,
        image: "/images/products/item_6.jpg",
        title: "ETH Me Outside",
        bid_number: 1.55,
        eth_number: 1.3,
        react_number: 159
    }, 
];


// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(4949);
;// CONCATENATED MODULE: ./redux/counterSlice.js

var initialState = {
    mblMenu: false,
    dropdown: false,
    collection_activity_item_data: [],
    trendingCategoryItemData: [],
    sortedtrendingCategoryItemData: [],
    collectiondata: [],
    sortedCollectionData: [],
    renkingData: [],
    filteredRenkingData: [],
    walletModal: false,
    bidsModal: false,
    buyModal: false,
    propartiesModalValue: false,
    trendingCategorySorText: ""
};
var counterSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "counter",
    initialState: initialState,
    reducers: {
        openMblMenu: function(state) {
            state.mblMenu = true;
        },
        closeMblMenu: function(state) {
            state.mblMenu = false;
        },
        openDropdown: function(state) {
            state.dropdown = true;
        },
        closeDropdown: function(state) {
            state.dropdown = false;
        },
        handle_collection_activity_item_data: function(state, payload) {
            state.collection_activity_item_data = payload.data;
        },
        walletModalShow: function(state) {
            state.walletModal = true;
        },
        walletModalhide: function(state) {
            state.walletModal = false;
        },
        bidsModalShow: function(state) {
            state.bidsModal = true;
        },
        bidsModalHide: function(state) {
            state.bidsModal = false;
        },
        buyModalShow: function(state) {
            state.buyModal = true;
        },
        buyModalHide: function(state) {
            state.buyModal = false;
        },
        showPropatiesModal: function(state) {
            state.propartiesModalValue = true;
        },
        closePropatiesModal: function(state) {
            state.propartiesModalValue = false;
        },
        updateTrendingCategoryItemData: function(state, action) {
            state.trendingCategoryItemData = action.payload;
            state.sortedtrendingCategoryItemData = action.payload;
        },
        updatetrendingCategorySorText: function(state, action) {
            var sortText = action.payload;
            if (sortText === "Price: Low to High") {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData.sort(function(a, b) {
                    return a.sortPrice - b.sortPrice;
                });
            } else if (sortText === "Price: high to low") {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData.sort(function(a, b) {
                    return b.sortPrice - a.sortPrice;
                });
            } else if (sortText === "Recently Added") {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData.sort(function(a, b) {
                    return a.addDate - b.addDate;
                });
            } else if (sortText === "Auction Ending Soon") {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData.sort(function(a, b) {
                    return b.addDate - a.addDate;
                });
            } else {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData;
            }
        },
        updateTrendingCategoryItemByInput: function(state, action) {
            var text = action.payload;
            if (text === "Verified Only") {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData.filter(function(item) {
                    return item.verified;
                });
            } else if (text === "NFSW Only") {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData.filter(function(item) {
                    return item.nfsw;
                });
            } else if (text === "Show Lazy Minted") {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData.filter(function(item) {
                    return item.lazyMinted;
                });
            } else {
                state.sortedtrendingCategoryItemData = state.trendingCategoryItemData;
            }
        },
        collectCollectionData: function(state, action) {
            var data = action.payload;
            state.collectiondata = data;
            state.sortedCollectionData = data;
        },
        updateCollectionData: function(state, action) {
            var text = action.payload;
            console.log(text);
            if (text === "trending") {
                var tampItem = state.collectiondata.filter(function(item) {
                    return item.trending;
                });
                state.sortedCollectionData = tampItem;
            }
            if (text === "top") {
                var tampItem1 = state.collectiondata.filter(function(item) {
                    return item.top;
                });
                state.sortedCollectionData = tampItem1;
            }
            if (text === "recent") {
                var tampItem2 = state.collectiondata.filter(function(item) {
                    return item.recent;
                });
                state.sortedCollectionData = tampItem2;
            }
        // state.sortedCollectionData = state.collectiondata;
        },
        collectRenkingData: function(state, action) {
            state.renkingData = action.payload;
            state.filteredRenkingData = action.payload;
        },
        updateRenkingData: function(state, action) {
            var text = action.payload;
            var tempItem = state.renkingData.filter(function(item) {
                return item.category === text;
            });
            if (text === "All") {
                tempItem = state.renkingData;
            }
            state.filteredRenkingData = tempItem;
        },
        updateRenkingDataByBlockchain: function(state, action) {
            var text = action.payload;
            var tempItem = state.renkingData.filter(function(item) {
                return item.blockchain === text;
            });
            if (text === "All") {
                tempItem = state.renkingData;
            }
            state.filteredRenkingData = tempItem;
        },
        updateRenkingDataByPostdate: function(state, action) {
            var text = action.payload;
            var tempItem = state.renkingData.filter(function(item) {
                return item.postDate === text;
            });
            if (text === "All Time" || text === "Last Year") {
                tempItem = state.renkingData;
            }
            state.filteredRenkingData = tempItem;
        }
    }
});
var _actions = counterSlice.actions;
// Action creators are generated for each case reducer function
var openMblMenu = _actions.openMblMenu, closeMblMenu = _actions.closeMblMenu, openDropdown = _actions.openDropdown, closeDropdown = _actions.closeDropdown, walletModalShow = _actions.walletModalShow, walletModalhide = _actions.walletModalhide, counterSlice_bidsModalShow = _actions.bidsModalShow, bidsModalHide = _actions.bidsModalHide, counterSlice_buyModalShow = _actions.buyModalShow, buyModalHide = _actions.buyModalHide, showPropatiesModal = _actions.showPropatiesModal, closePropatiesModal = _actions.closePropatiesModal, counterSlice_updatetrendingCategorySorText = _actions.updatetrendingCategorySorText, counterSlice_updateTrendingCategoryItemData = _actions.updateTrendingCategoryItemData, counterSlice_updateTrendingCategoryItemByInput = _actions.updateTrendingCategoryItemByInput, collectCollectionData = _actions.collectCollectionData, updateCollectionData = _actions.updateCollectionData, collectRenkingData = _actions.collectRenkingData, counterSlice_updateRenkingData = _actions.updateRenkingData, counterSlice_updateRenkingDataByBlockchain = _actions.updateRenkingDataByBlockchain, counterSlice_updateRenkingDataByPostdate = _actions.updateRenkingDataByPostdate;
/* harmony default export */ var redux_counterSlice = (counterSlice.reducer);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
;// CONCATENATED MODULE: ./components/likes.jsx



var likes_Likes = function(param) {
    var like = param.like, _classes = param.classes, classes = _classes === void 0 ? "dark:bg-jacarta-700 absolute top-3 right-3 flex items-center space-x-1 rounded-md bg-white p-2" : _classes;
    var ref = useState(typeof like === "string" ? +like - 1 : like - 1), likeState = ref[0], setLikeState = ref[1];
    var ref1 = useState(likeState), likeNumber = ref1[0], setlikeNumber = ref1[1];
    var handleLike = function() {
        if (likeState >= likeNumber) {
            setlikeNumber(function(prev) {
                return prev + 1;
            });
        } else {
            setlikeNumber(function(prev) {
                return prev - 1;
            });
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: classes,
        onClick: handleLike,
        children: [
            /*#__PURE__*/ _jsx(Tippy, {
                content: /*#__PURE__*/ _jsx("span", {
                    children: "Favorite"
                }),
                children: /*#__PURE__*/ _jsx("button", {
                    className: "js-likes relative cursor-pointer",
                    children: likeState === likeNumber ? /*#__PURE__*/ _jsx("svg", {
                        className: "icon icon-heart-fill dark:fill-jacarta-200 fill-jacarta-500 hover:fill-red dark:hover:fill-red h-4 w-4",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "/icons.svg#icon-hert-fill"
                        })
                    }) : /*#__PURE__*/ _jsx("svg", {
                        className: "icon icon-heart-fill dark:fill-jacarta-200 fill-jacarta-500 hover:fill-red dark:hover:fill-red h-4 w-4",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "/icons.svg#icon-heart-fill"
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "dark:text-jacarta-200 text-sm",
                children: likeNumber
            })
        ]
    });
};
/* harmony default export */ var likes = ((/* unused pure expression or super */ null && (likes_Likes)));

;// CONCATENATED MODULE: ./components/carousel/bidsCarousel.jsx














var bidsCarousel_BidsCarousel = function() {
    var dispatch = useDispatch();
    var handleclick = function() {
        console.log("clicked on ");
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Swiper, {
                modules: [
                    Navigation,
                    Pagination,
                    Scrollbar
                ],
                spaceBetween: 30,
                slidesPerView: "auto",
                loop: true,
                breakpoints: {
                    240: {
                        slidesPerView: 1
                    },
                    565: {
                        slidesPerView: 2
                    },
                    1000: {
                        slidesPerView: 3
                    },
                    1100: {
                        slidesPerView: 4
                    }
                },
                navigation: {
                    nextEl: ".bids-swiper-button-next",
                    prevEl: ".bids-swiper-button-prev"
                },
                className: " card-slider-4-columns !py-5",
                children: bidsData.map(function(item) {
                    var id = item.id, image = item.image, title = item.title, bid_number = item.bid_number, eth_number = item.eth_number, react_number = item.react_number;
                    var itemLink = image.split("/").slice(-1).toString().replace(".jpg", "");
                    return /*#__PURE__*/ _jsx(SwiperSlide, {
                        className: "text-white",
                        children: /*#__PURE__*/ _jsx("article", {
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg text-jacarta-500",
                                children: [
                                    /*#__PURE__*/ _jsx("figure", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "/item/" + itemLink,
                                            children: /*#__PURE__*/ _jsx("a", {
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "w-full",
                                                    children: /*#__PURE__*/ _jsx(Image, {
                                                        src: image,
                                                        alt: title,
                                                        height: 230,
                                                        width: 230,
                                                        layout: "responsive",
                                                        objectFit: "cover",
                                                        className: "rounded-[0.625rem] w-full",
                                                        loading: "lazy"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mt-4 flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ _jsx(Link, {
                                                href: "/item/" + itemLink,
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        className: "font-display text-jacarta-700 hover:text-accent text-base dark:text-white",
                                                        children: title
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "dark:border-jacarta-600 border-jacarta-100 flex items-center whitespace-nowrap rounded-md border py-1 px-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Tippy, {
                                                        content: /*#__PURE__*/ _jsx("span", {
                                                            children: "ETH"
                                                        }),
                                                        children: /*#__PURE__*/ _jsx("img", {
                                                            src: "/images/eth-icon.svg",
                                                            alt: "",
                                                            className: "w-3 h-3 mr-1"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "text-green text-sm font-medium tracking-tight",
                                                        children: [
                                                            eth_number,
                                                            " ETH"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mt-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "dark:text-jacarta-300 text-jacarta-500",
                                                children: "Current Bid"
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "dark:text-jacarta-100 text-jacarta-700",
                                                children: [
                                                    bid_number,
                                                    " ETH"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mt-8 flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "text-accent font-display text-sm font-semibold",
                                                onClick: function() {
                                                    return dispatch(bidsModalShow());
                                                },
                                                children: "Place bid"
                                            }),
                                            /*#__PURE__*/ _jsx(Likes, {
                                                like: react_number,
                                                classes: "flex items-center space-x-1"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, id);
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "group bids-swiper-button-prev swiper-button-prev shadow-white-volume absolute !top-1/2 !-left-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-jacarta-700 text-xl sm:!-left-6 after:hidden",
                children: /*#__PURE__*/ _jsx(MdKeyboardArrowLeft, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "group bids-swiper-button-next swiper-button-next shadow-white-volume absolute !top-1/2 !-right-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-jacarta-700 text-xl sm:!-right-6 after:hidden",
                children: /*#__PURE__*/ _jsx(MdKeyboardArrowRight, {})
            })
        ]
    });
};
/* harmony default export */ var bidsCarousel = ((/* unused pure expression or super */ null && (bidsCarousel_BidsCarousel)));

;// CONCATENATED MODULE: ./components/bids/bids.jsx






var Bids = function(param) {
    var _classes = param.classes, classes = _classes === void 0 ? "pt-10 pb-24" : _classes, bgWhite = param.bgWhite;
    return /*#__PURE__*/ _jsxs("section", {
        className: classes,
        children: [
            bgWhite && /*#__PURE__*/ _jsx("picture", {
                className: "pointer-events-none absolute inset-0 -z-10 dark:hidden",
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/images/gradient_light.jpg",
                    alt: "gradient",
                    className: "h-full w-full"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ _jsx(HeadLine, {
                        text: "Samples",
                        image: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/64/1f525.png",
                        classes: "font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative",
                        children: /*#__PURE__*/ _jsx(BidsCarousel, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var bids = ((/* unused pure expression or super */ null && (Bids)));

// EXTERNAL MODULE: ./data/collection_data.js
var data_collection_data = __webpack_require__(2538);
// EXTERNAL MODULE: ./components/headLine.jsx
var headLine = __webpack_require__(422);
;// CONCATENATED MODULE: ./components/collectrions/top_collection.jsx

/* eslint-disable @next/next/no-img-element */ 




var Top_collection = function() {
    var ref = useState("last 7 days"), timeActiveText = ref[0], setTimeActiveText = ref[1];
    var ref1 = useState(collection_data), data = ref1[0], setData = ref1[1];
    var ref2 = useState(false), dropdownShow = ref2[0], setDropdownShow = ref2[1];
    var timeText = [
        {
            id: 1,
            text: "Last 24 Hours"
        },
        {
            id: 2,
            text: "Last 7 days"
        },
        {
            id: 3,
            text: "Last 30 days"
        }, 
    ];
    var handleFilter = function(text) {
        setTimeActiveText(text);
        var newCollectionData = collection_data.filter(function(item) {
            if (text === "Last 30 days") {
                return item;
            }
            return item.postDate === text;
        });
        setData(newCollectionData);
    };
    var handleDropdown = function(e) {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".dropdown-toggle")) {
                if (dropdownShow) {
                    setDropdownShow(false);
                } else {
                    setDropdownShow(true);
                }
            } else {
                setDropdownShow(false);
            }
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("section", {
            className: "dark:bg-jacarta-800 relative py-24",
            children: [
                /*#__PURE__*/ _jsx("picture", {
                    className: "pointer-events-none absolute inset-0 -z-10 dark:hidden",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/images/gradient_light.jpg",
                        alt: "gradient",
                        className: "h-full w-full"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "font-display text-jacarta-700 mb-12 text-center text-lg sm:text-3xl dark:text-white flex justify-center items-center gap-x-3",
                            children: [
                                /*#__PURE__*/ _jsx(HeadLine, {
                                    text: "Top collections over",
                                    classes: "inline"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "dropdown cursor-pointer relative",
                                    children: [
                                        /*#__PURE__*/ _jsxs("button", {
                                            className: "dropdown-toggle text-accent inline-flex items-center",
                                            type: "button",
                                            onClick: function(e) {
                                                return handleDropdown(e);
                                            },
                                            children: [
                                                timeActiveText,
                                                /*#__PURE__*/ _jsxs("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 24 24",
                                                    width: "24",
                                                    height: "24",
                                                    className: "fill-accent h-8 w-8",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("path", {
                                                            fill: "none",
                                                            d: "M0 0h24v24H0z"
                                                        }),
                                                        /*#__PURE__*/ _jsx("path", {
                                                            d: "M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: dropdownShow ? "dropdown-menu dark:bg-jacarta-800 z-10  min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show text-jacarta-700 dark:text-white absolute m-0 top-full" : "dropdown-menu dark:bg-jacarta-800 z-10  min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl hidden text-jacarta-700 dark:text-white absolute m-0 top-full",
                                            children: timeText.map(function(param) {
                                                var id = param.id, text = param.text;
                                                return /*#__PURE__*/ _jsx("button", {
                                                    onClick: function() {
                                                        handleFilter(text);
                                                    },
                                                    className: "block dropdown-text",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        className: "dropdown-item font-normal text-base dark:hover:bg-jacarta-600 hover:bg-jacarta-50 block rounded-xl px-5 py-2 transition-colors",
                                                        children: text
                                                    })
                                                }, id);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-[1.875rem] lg:grid-cols-4",
                            children: data.map(function(item) {
                                var id = item.id, image = item.image, title = item.title, icon = item.icon, amount = item.amount, postTime = item.postTime;
                                var itemLink = image.split("/").slice(-1).toString().replace(".jpg", "");
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "border-jacarta-100 dark:bg-jacarta-700 rounded-2xl flex border bg-white py-4 px-7 transition-shadow hover:shadow-lg dark:border-transparent",
                                    children: [
                                        /*#__PURE__*/ _jsx("figure", {
                                            className: "mr-4 shrink-0",
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "/collection/" + itemLink,
                                                children: /*#__PURE__*/ _jsxs("a", {
                                                    className: "relative block",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Image, {
                                                            src: image,
                                                            alt: title,
                                                            className: "rounded-2lg",
                                                            height: 48,
                                                            width: 48,
                                                            objectFit: "cover"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "dark:border-jacarta-600 bg-jacarta-700 absolute -left-3 top-1/2 flex h-6 w-6 -translate-y-2/4 items-center justify-center rounded-full border-2 border-white text-xs text-white",
                                                            children: id
                                                        }),
                                                        icon && /*#__PURE__*/ _jsx("div", {
                                                            className: "dark:border-jacarta-600 bg-green absolute -left-3 top-[60%] flex h-6 w-6 items-center justify-center rounded-full border-2 border-white",
                                                            "data-tippy-content": "Verified Collection",
                                                            children: /*#__PURE__*/ _jsxs("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 24 24",
                                                                width: "24",
                                                                height: "24",
                                                                className: "h-[.875rem] w-[.875rem] fill-white",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("path", {
                                                                        fill: "none",
                                                                        d: "M0 0h24v24H0z"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("path", {
                                                                        d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    href: "/collection/" + itemLink,
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "block",
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: "font-display text-jacarta-700 hover:text-accent font-semibold dark:text-white",
                                                            children: title
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "dark:text-jacarta-300 text-sm",
                                                    children: [
                                                        amount,
                                                        " ETH"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, id);
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-10 text-center",
                            children: /*#__PURE__*/ _jsx(Link, {
                                href: "/rankings",
                                children: /*#__PURE__*/ _jsx("a", {
                                    className: "bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all",
                                    children: "Go to Rankings"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var top_collection = ((/* unused pure expression or super */ null && (Top_collection)));

;// CONCATENATED MODULE: ./data/categories_data.js
var categories_data_tranding_category_filter = [
    {
        id: 0,
        text: "all"
    },
    {
        id: 1,
        svg: "art",
        text: "art"
    },
    {
        id: 2,
        svg: "collection",
        text: "Collectibles"
    },
    {
        id: 3,
        svg: "domain",
        text: "domain"
    },
    {
        id: 4,
        svg: "music",
        text: "music"
    },
    {
        id: 5,
        svg: "photography",
        text: "photography"
    },
    {
        id: 6,
        svg: "world",
        text: "virtual world"
    }, 
];
var categories_data_trendingCategoryData = [
    {
        image: "/images/products/item_5.jpg",
        id: "Flourishing Cat #1800",
        category: "art",
        title: "Flourishing Cat #180",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 1,
        sortPrice: 8.49,
        price: "From 8.49 ETH",
        bidLimit: 8,
        bidCount: 2,
        likes: 15,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_1.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_1.png"
        }
    },
    {
        image: "/images/products/item_4.jpg",
        id: "Amazing NFT art1",
        category: "Collectibles",
        title: "Amazing NFT art",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 2,
        sortPrice: 5.9,
        price: "From 5.9 ETH",
        bidLimit: 7,
        bidCount: 1,
        likes: 188,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_2.png"
        }
    },
    {
        image: "/images/products/item_7.jpg",
        id: "SwagFox#1332",
        category: "domain",
        title: "SwagFox#133",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 3,
        sortPrice: 0.078,
        price: "0.078 ETH",
        bidLimit: 3,
        bidCount: 1,
        likes: 160,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_3.png"
        }
    },
    {
        image: "/images/products/item_6.jpg",
        id: "Splendid Girl3",
        category: "music",
        title: "Splendid Girl",
        nfsw: true,
        lazyMinted: true,
        verified: false,
        addDate: 4,
        sortPrice: 10,
        price: "10 ETH",
        bidLimit: 3,
        bidCount: 2,
        likes: 159,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_4.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_8.jpg",
        id: "Monkeyme#1554",
        category: "photography",
        title: "Monkeyme#155",
        nfsw: false,
        lazyMinted: false,
        verified: true,
        addDate: 5,
        sortPrice: 5,
        price: "From 5 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 32,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_9.jpg",
        id: "Jedidia#1495",
        category: "virtual world",
        title: "Jedidia#149",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 6,
        sortPrice: 0.16,
        price: "0.16 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 25,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_6.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_10.jpg",
        id: "Artof Eve6",
        category: "art",
        title: "Artof Eve",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 7,
        sortPrice: 0.13,
        price: "0.13 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 55,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_7.png"
        }
    },
    {
        image: "/images/products/item_11.jpg",
        id: "Asuna #16497",
        category: "collection",
        title: "Asuna#1649",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 8,
        sortPrice: 0.8,
        price: "0.8 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 70,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_8.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_11.jpg",
        id: "Asuna#164978",
        category: "collection",
        title: "Asuna#1649",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 9,
        sortPrice: 0.8,
        price: "0.8 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 70,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_8.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_12_lg.jpg",
        id: "Amazing NFT art9",
        category: "Collectibles",
        title: "Amazing NFT art",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 10,
        sortPrice: 5.9,
        price: "From 5.9 ETH",
        bidLimit: 7,
        bidCount: 1,
        likes: 188,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_2.png"
        }
    },
    {
        image: "/images/products/item_13_lg.jpg",
        id: "SwagFox#13310",
        category: "domain",
        title: "SwagFox#133",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 12,
        sortPrice: 0.078,
        price: "0.078 ETH",
        bidLimit: 3,
        bidCount: 1,
        likes: 160,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_3.png"
        }
    },
    {
        image: "/images/products/item_14_lg.jpg",
        id: "Splendid Girl311",
        category: "music",
        title: "Splendid Girl",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 13,
        sortPrice: 10,
        price: "10 ETH",
        bidLimit: 3,
        bidCount: 2,
        likes: 159,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_4.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_15_lg.jpg",
        id: "Monkeyme#15512",
        category: "photography",
        title: "Monkeyme#155",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 14,
        sortPrice: 5,
        price: "From 5 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 32,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_16_lg.jpg",
        id: "Jedidia#14913",
        category: "virtual world",
        title: "Jedidia#149",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 15,
        sortPrice: 0.16,
        price: "0.16 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 25,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_6.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_5.jpg",
        id: "FlourishingCat#18014",
        category: "art",
        title: "Flourishing Cat #180",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 16,
        sortPrice: 8.49,
        price: "From 8.49 ETH",
        bidLimit: 8,
        bidCount: 2,
        likes: 15,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_1.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_1.png"
        }
    },
    {
        image: "/images/products/item_4.jpg",
        id: "Amazing NFT art15",
        category: "Collectibles",
        title: "Amazing NFT art",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 16,
        sortPrice: 5.9,
        price: "From 5.9 ETH",
        bidLimit: 7,
        bidCount: 1,
        likes: 188,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_2.png"
        }
    },
    {
        image: "/images/products/item_7.jpg",
        id: "SwagFox#13316",
        category: "domain",
        title: "SwagFox#133",
        nfsw: false,
        lazyMinted: false,
        verified: false,
        addDate: 17,
        sortPrice: 0.078,
        price: "0.078 ETH",
        bidLimit: 3,
        bidCount: 1,
        likes: 160,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_3.png"
        }
    },
    {
        image: "/images/products/item_6.jpg",
        id: "Splendid Girl7",
        category: "music",
        title: "Splendid Girl",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 18,
        sortPrice: 10,
        price: "10 ETH",
        bidLimit: 3,
        bidCount: 2,
        likes: 159,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_4.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_8.jpg",
        id: "Monkeyme#15548",
        category: "photography",
        title: "Monkeyme#155",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 19,
        sortPrice: 5,
        price: "From 5 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 32,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_9.jpg",
        id: "Jedidia#14959",
        category: "virtual world",
        title: "Jedidia#149",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 20,
        sortPrice: 0.16,
        price: "0.16 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 25,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_6.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_10.jpg",
        id: "Artof Eve60",
        category: "art",
        title: "Artof Eve",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 21,
        sortPrice: 0.13,
        price: "0.13 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 55,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_7.png"
        }
    },
    {
        image: "/images/products/item_11.jpg",
        id: "Asuna #164971",
        category: "collection",
        title: "Asuna#1649",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 22,
        sortPrice: 0.8,
        price: "0.8 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 70,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_8.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_11.jpg",
        id: "Asuna#1649782",
        category: "collection",
        title: "Asuna#1649",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 23,
        sortPrice: 0.8,
        price: "0.8 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 70,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_8.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_12_lg.jpg",
        id: "Amazing NFT art93",
        category: "Collectibles",
        title: "Amazing NFT art",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 24,
        sortPrice: 5.9,
        price: "From 5.9 ETH",
        bidLimit: 7,
        bidCount: 1,
        likes: 188,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_2.png"
        }
    },
    {
        image: "/images/products/item_13_lg.jpg",
        id: "SwagFox#133104",
        category: "domain",
        title: "SwagFox#133",
        nfsw: false,
        lazyMinted: true,
        verified: false,
        addDate: 25,
        sortPrice: 0.078,
        price: "0.078 ETH",
        bidLimit: 3,
        bidCount: 1,
        likes: 160,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_3.png"
        }
    },
    {
        image: "/images/products/item_14_lg.jpg",
        id: "Splendid Girl3115",
        category: "music",
        title: "Splendid Girl",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 26,
        sortPrice: 10,
        price: "10 ETH",
        bidLimit: 3,
        bidCount: 2,
        likes: 159,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_4.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_15_lg.jpg",
        id: "Monkeyme#155126",
        category: "photography",
        title: "Monkeyme#155",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 27,
        sortPrice: 5,
        price: "From 5 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 32,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_16_lg.jpg",
        id: "Jedidia#149137",
        category: "virtual world",
        title: "Jedidia#149",
        nfsw: false,
        lazyMinted: true,
        verified: false,
        addDate: 28,
        sortPrice: 0.16,
        price: "0.16 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 25,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_6.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    }, 
];


;// CONCATENATED MODULE: ./components/dropdown/Auctions_dropdown.jsx


var Auctions_dropdown_Auctions_dropdown = function(param) {
    var classes = param.classes;
    var ref = useState(false), dropdownShow = ref[0], setDropdownShow = ref[1];
    var handleDropdown = function() {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".trending-dots")) {
                if (dropdownShow) {
                    setDropdownShow(false);
                } else {
                    setDropdownShow(true);
                }
            } else {
                setDropdownShow(false);
            }
        });
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative",
            children: /*#__PURE__*/ _jsxs("div", {
                className: classes,
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        onClick: handleDropdown,
                        className: "dropdown-toggle trending-dots inline-flex h-10 w-10 items-center justify-center text-sm show",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "16",
                            height: "4",
                            viewBox: "0 0 16 4",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "dark:fill-jacarta-200 fill-jacarta-500",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "2",
                                    cy: "2",
                                    r: "2"
                                }),
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "8",
                                    cy: "2",
                                    r: "2"
                                }),
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "14",
                                    cy: "2",
                                    r: "2"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: dropdownShow ? "dropdown-menu-end dark:bg-jacarta-800 z-10 min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show text-jacarta-500 absolute top-full right-0" : "dropdown-menu-end dark:bg-jacarta-800 z-10 min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl hidden text-jacarta-500 absolute top-full right-0",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                children: "New bid"
                            }),
                            /*#__PURE__*/ _jsx("hr", {
                                className: "dark:bg-jacarta-600 bg-jacarta-100 my-2 mx-4 h-px border-0"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                children: "Refresh Metadata"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                children: "Share"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                children: "Report"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var dropdown_Auctions_dropdown = ((/* unused pure expression or super */ null && (Auctions_dropdown_Auctions_dropdown)));

;// CONCATENATED MODULE: ./components/categories/categoryItem.jsx










var categoryItem_CategoryItem = function() {
    var sortedtrendingCategoryItemData = useSelector(function(state) {
        return state.counter;
    }).sortedtrendingCategoryItemData;
    var dispatch = useDispatch();
    return /*#__PURE__*/ _jsx("div", {
        className: "grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4",
        children: sortedtrendingCategoryItemData.map(function(item) {
            var id = item.id, image = item.image, title = item.title, price = item.price, bidLimit = item.bidLimit, bidCount = item.bidCount, likes = item.likes, creator = item.creator, owner = item.owner;
            var itemLink = image.split("/").slice(-1).toString().replace(".jpg", "").replace(".gif", "");
            return /*#__PURE__*/ _jsx("article", {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg",
                    children: [
                        /*#__PURE__*/ _jsxs("figure", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/item/".concat(itemLink),
                                    children: /*#__PURE__*/ _jsx("a", {
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: image,
                                            alt: "item 5",
                                            className: "w-full h-[230px] rounded-[0.625rem] object-cover"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Likes, {
                                    like: likes
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "absolute left-3 -bottom-3",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "flex -space-x-2",
                                        children: [
                                            /*#__PURE__*/ _jsx(Link, {
                                                href: "/item/".concat(itemLink),
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    children: /*#__PURE__*/ _jsx(Tippy, {
                                                        content: /*#__PURE__*/ _jsxs("span", {
                                                            children: [
                                                                "creator: ",
                                                                creator.name
                                                            ]
                                                        }),
                                                        children: /*#__PURE__*/ _jsx("img", {
                                                            src: creator.image,
                                                            alt: "creator",
                                                            className: "dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Link, {
                                                href: "/item/".concat(itemLink),
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    children: /*#__PURE__*/ _jsx(Tippy, {
                                                        content: /*#__PURE__*/ _jsxs("span", {
                                                            children: [
                                                                "creator: ",
                                                                owner.name
                                                            ]
                                                        }),
                                                        children: /*#__PURE__*/ _jsx("img", {
                                                            src: owner.image,
                                                            alt: "owner",
                                                            layout: "fill",
                                                            className: "dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-7 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/item/".concat(itemLink),
                                    children: /*#__PURE__*/ _jsx("a", {
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "font-display text-jacarta-700 hover:text-accent text-base dark:text-white",
                                            children: title
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Auctions_dropdown, {
                                    classes: "dark:hover:bg-jacarta-600 dropup hover:bg-jacarta-100 rounded-full "
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-2 text-sm",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "dark:text-jacarta-200 text-jacarta-700 mr-1",
                                    children: price
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "dark:text-jacarta-300 text-jacarta-500",
                                    children: [
                                        bidCount,
                                        "/",
                                        bidLimit
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-8 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    className: "text-accent font-display text-sm font-semibold",
                                    onClick: function() {
                                        return dispatch(buyModalShow());
                                    },
                                    children: "Buy now"
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/item/".concat(itemLink),
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        className: "group flex items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("svg", {
                                                className: "icon icon-history group-hover:fill-accent dark:fill-jacarta-200 fill-jacarta-500 mr-1 mb-[3px] h-4 w-4",
                                                children: /*#__PURE__*/ _jsx("use", {
                                                    xlinkHref: "/icons.svg#icon-history"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "group-hover:text-accent font-display dark:text-jacarta-200 text-sm font-semibold",
                                                children: "View History"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }, id);
        })
    });
};
/* harmony default export */ var categoryItem = ((/* unused pure expression or super */ null && (categoryItem_CategoryItem)));

;// CONCATENATED MODULE: ./components/dropdown/recently_added_dropdown.jsx






var recently_added_dropdown_Recently_added_dropdown = function(param1) {
    var data = param1.data, dropdownFor = param1.dropdownFor;
    var dispatch = useDispatch();
    var ref = useState(""), currencyValFrom = ref[0], setCurrencyValFrom = ref[1];
    var ref1 = useState(""), currencyValTo = ref1[0], setCurrencyValTo = ref1[1];
    var ref2 = useState(1), sortActive = ref2[0], setsortActive = ref2[1];
    var ref3 = useState(""), sortFilterText = ref3[0], setSortFilterText = ref3[1];
    var ref4 = useState(false), renkingCategoriesdropdownShow = ref4[0], setRenkingCategoriesDropdownShow = ref4[1];
    var ref5 = useState(false), blockChaindropdownShow = ref5[0], setBlockChainDropdownShow = ref5[1];
    var ref6 = useState(false), itemDateDropdown = ref6[0], setItemDateDropdown = ref6[1];
    var ref7 = useState(false), categoryDropdown = ref7[0], setCategoryDropdown = ref7[1];
    var ref8 = useState(false), dropdownSale = ref8[0], setDropdownSale = ref8[1];
    var ref9 = useState(false), currencyDropdown = ref9[0], setCurrencyDropdown = ref9[1];
    var handleRenkingCategoriesDropdown = function() {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".rankingCategoriesDropdown")) {
                if (renkingCategoriesdropdownShow) {
                    setRenkingCategoriesDropdownShow(false);
                } else {
                    setRenkingCategoriesDropdownShow(true);
                }
            } else {
                setRenkingCategoriesDropdownShow(false);
            }
        });
    };
    var handleBlockChainDropdown = function() {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".blockchainDropdown")) {
                if (blockChaindropdownShow) {
                    setBlockChainDropdownShow(false);
                } else {
                    setBlockChainDropdownShow(true);
                }
            } else {
                setBlockChainDropdownShow(false);
            }
        });
    };
    var handleItemDateDropdown = function() {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".itemDateDropdown")) {
                if (itemDateDropdown) {
                    setItemDateDropdown(false);
                } else {
                    setItemDateDropdown(true);
                }
            } else {
                setItemDateDropdown(false);
            }
        });
    };
    var handleCategoryDropdown = function() {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".category-dropdown")) {
                if (categoryDropdown) {
                    setCategoryDropdown(false);
                } else {
                    setCategoryDropdown(true);
                }
            } else {
                setCategoryDropdown(false);
            }
        });
    };
    var handleSaleDropdown = function() {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".dropdown-sale")) {
                if (dropdownSale) {
                    setDropdownSale(false);
                } else {
                    setDropdownSale(true);
                }
            } else {
                setDropdownSale(false);
            }
        });
    };
    var handleCurrencyDropdown = function() {
        console.log("first");
        if (currencyDropdown) {
            setCurrencyDropdown(false);
        } else {
            setCurrencyDropdown(true);
        }
    };
    // console.log(blockChaindropdownShow);
    useEffect(function() {
        dispatch(updatetrendingCategorySorText(sortFilterText));
    }, [
        sortFilterText,
        dispatch
    ]);
    var inputData = [
        {
            id: 1,
            text: "Verified Only"
        },
        {
            id: 2,
            text: "NFSW Only"
        },
        {
            id: 3,
            text: "Show Lazy Minted"
        }, 
    ];
    var handleInput = function(e, text) {
        if (e.target.checked) {
            // console.log(text);
            dispatch(updateTrendingCategoryItemByInput(text));
        } else {
            dispatch(updateTrendingCategoryItemByInput(""));
        }
    };
    var handleCurrencyValTo = function(e) {
        var value = e.target.value;
        if (value < 0) {
            setCurrencyValTo(0);
        } else {
            setCurrencyValTo(value);
        }
    };
    var handleCurrencyValFrom = function(e) {
        var value = e.target.value;
        if (value < 0) {
            setCurrencyValFrom(0);
        } else {
            setCurrencyValFrom(value);
        }
    };
    if (dropdownFor === "recently_added") {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("div", {
                className: "dropdown relative my-1 cursor-pointer",
                children: /*#__PURE__*/ _jsx(Tippy, {
                    animation: "fade",
                    arrow: false,
                    trigger: "click",
                    interactive: "true",
                    placement: "bottom",
                    className: "tooltip-container",
                    content: /*#__PURE__*/ _jsxs("div", {
                        className: "dropdown-menu dark:bg-jacarta-800 z-10 hidden min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show text-jacarta-500",
                        "aria-labelledby": "categoriesSort",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-display text-jacarta-300 block px-5 py-2 text-sm font-semibold",
                                children: "Sort By"
                            }),
                            data.map(function(item) {
                                var id = item.id, text = item.text;
                                return /*#__PURE__*/ _jsxs("button", {
                                    className: "dropdown-item font-display text-jacarta-700 dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                    onClick: function() {
                                        setsortActive(id);
                                        setSortFilterText(text);
                                    },
                                    children: [
                                        text,
                                        sortActive === id && /*#__PURE__*/ _jsxs("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "24",
                                            height: "24",
                                            className: "fill-accent mb-[3px] h-4 w-4",
                                            children: [
                                                /*#__PURE__*/ _jsx("path", {
                                                    fill: "none",
                                                    d: "M0 0h24v24H0z"
                                                }),
                                                /*#__PURE__*/ _jsx("path", {
                                                    d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                                                })
                                            ]
                                        })
                                    ]
                                }, id);
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-display text-jacarta-300 block px-5 py-2 text-sm font-semibold",
                                children: "Options"
                            }),
                            inputData.map(function(param) {
                                var id = param.id, text = param.text;
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                    children: /*#__PURE__*/ _jsxs("span", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: text
                                            }),
                                            /*#__PURE__*/ _jsx("input", {
                                                type: "checkbox",
                                                name: "check",
                                                className: "checked:bg-accent checked:focus:bg-accent checked:hover:bg-accent after:bg-jacarta-400 bg-jacarta-100 relative h-4 w-7 cursor-pointer appearance-none rounded-lg border-none shadow-none after:absolute after:top-0.5 after:left-0.5 after:h-3 after:w-3 after:rounded-full after:transition-all checked:bg-none checked:after:left-3.5 checked:after:bg-white focus:ring-transparent focus:ring-offset-0",
                                                onChange: function(e) {
                                                    return handleInput(e, text);
                                                }
                                            })
                                        ]
                                    })
                                }, id);
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "dark:bg-jacarta-700 dropdown-toggle border-jacarta-100 dark:border-jacarta-600 inline-flex w-48 items-center justify-between rounded-lg border bg-white py-2 px-3 text-sm dark:text-white",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-display",
                                children: "Trending"
                            }),
                            /*#__PURE__*/ _jsxs("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                width: "24",
                                height: "24",
                                className: "fill-jacarta-500 h-4 w-4 dark:fill-white",
                                children: [
                                    /*#__PURE__*/ _jsx("path", {
                                        fill: "none",
                                        d: "M0 0h24v24H0z"
                                    }),
                                    /*#__PURE__*/ _jsx("path", {
                                        d: "M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    } else if (dropdownFor === "blockchain") {
        return /*#__PURE__*/ _jsxs("div", {
            className: "my-1 mr-2.5 relative",
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    className: "group dropdown-toggle blockchainDropdown dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white",
                    onClick: handleBlockChainDropdown,
                    children: [
                        /*#__PURE__*/ _jsxs("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            className: "fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    fill: "none",
                                    d: "M0 0h24v24H0z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M20 16h2v6h-6v-2H8v2H2v-6h2V8H2V2h6v2h8V2h6v6h-2v8zm-2 0V8h-2V6H8v2H6v8h2v2h8v-2h2zM4 4v2h2V4H4zm0 14v2h2v-2H4zM18 4v2h2V4h-2zm0 14v2h2v-2h-2z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: "Blockchain"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: blockChaindropdownShow ? "dropdown-menu dark:bg-jacarta-800 z-10 min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show absolute top-full right-0" : "dropdown-menu dark:bg-jacarta-800 z-10 min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl hidden absolute top-full right-0",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "flex flex-col flex-wrap",
                        children: data.map(function(param) {
                            var id = param.id, text = param.text;
                            return /*#__PURE__*/ _jsx("li", {
                                onClick: function() {
                                    return setsortActive(id);
                                },
                                children: /*#__PURE__*/ _jsxs("button", {
                                    className: "dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                    onClick: function() {
                                        return dispatch(updateRenkingDataByBlockchain(text));
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-jacarta-700 dark:text-white",
                                            children: text
                                        }),
                                        sortActive === id && /*#__PURE__*/ _jsxs("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "24",
                                            height: "24",
                                            className: "fill-accent mb-[3px] h-4 w-4",
                                            children: [
                                                /*#__PURE__*/ _jsx("path", {
                                                    fill: "none",
                                                    d: "M0 0h24v24H0z"
                                                }),
                                                /*#__PURE__*/ _jsx("path", {
                                                    d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, id);
                        })
                    })
                })
            ]
        });
    } else if (dropdownFor === "category") {
        return /*#__PURE__*/ _jsxs("div", {
            className: "my-1 mr-2.5 relative",
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    className: "group dropdown-toggle category-dropdown dark:border-jacarta-600 dark:bg-jacarta-700 dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white",
                    onClick: handleCategoryDropdown,
                    children: [
                        /*#__PURE__*/ _jsxs("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            className: "fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    fill: "none",
                                    d: "M0 0h24v24H0z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M14 10v4h-4v-4h4zm2 0h5v4h-5v-4zm-2 11h-4v-5h4v5zm2 0v-5h5v4a1 1 0 0 1-1 1h-4zM14 3v5h-4V3h4zm2 0h4a1 1 0 0 1 1 1v4h-5V3zm-8 7v4H3v-4h5zm0 11H4a1 1 0 0 1-1-1v-4h5v5zM8 3v5H3V4a1 1 0 0 1 1-1h4z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: "Category"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: categoryDropdown ? "dropdown-menu dark:bg-jacarta-800 z-10 min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show absolute top-full right-0" : "dropdown-menu dark:bg-jacarta-800 z-10 min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl hidden absolute top-full right-0",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "flex flex-col flex-wrap",
                        children: data.map(function(param) {
                            var id = param.id, text = param.text;
                            return /*#__PURE__*/ _jsx("li", {
                                onClick: function() {
                                    return setsortActive(id);
                                },
                                children: /*#__PURE__*/ _jsxs("button", {
                                    className: "dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-jacarta-700 dark:text-white",
                                            children: text
                                        }),
                                        sortActive === id && /*#__PURE__*/ _jsxs("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "24",
                                            height: "24",
                                            className: "fill-accent mb-[3px] h-4 w-4",
                                            children: [
                                                /*#__PURE__*/ _jsx("path", {
                                                    fill: "none",
                                                    d: "M0 0h24v24H0z"
                                                }),
                                                /*#__PURE__*/ _jsx("path", {
                                                    d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, id);
                        })
                    })
                })
            ]
        });
    } else if (dropdownFor === "rankingCategories") {
        return /*#__PURE__*/ _jsxs("div", {
            className: "my-1 mr-2.5 relative",
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    className: "group dropdown-toggle rankingCategoriesDropdown dark:border-jacarta-600 dark:bg-jacarta-700 dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white",
                    onClick: handleRenkingCategoriesDropdown,
                    children: [
                        /*#__PURE__*/ _jsxs("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            className: "fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    fill: "none",
                                    d: "M0 0h24v24H0z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M14 10v4h-4v-4h4zm2 0h5v4h-5v-4zm-2 11h-4v-5h4v5zm2 0v-5h5v4a1 1 0 0 1-1 1h-4zM14 3v5h-4V3h4zm2 0h4a1 1 0 0 1 1 1v4h-5V3zm-8 7v4H3v-4h5zm0 11H4a1 1 0 0 1-1-1v-4h5v5zM8 3v5H3V4a1 1 0 0 1 1-1h4z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: "all Category"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: renkingCategoriesdropdownShow ? "dropdown-menu dark:bg-jacarta-800 z-10 min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show absolute top-full right-0" : "dropdown-menu dark:bg-jacarta-800 z-10 min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl absolute top-full right-0 hidden",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "flex flex-col flex-wrap",
                        children: data.map(function(param) {
                            var id = param.id, text = param.text;
                            return /*#__PURE__*/ _jsx("li", {
                                onClick: function() {
                                    return setsortActive(id);
                                },
                                children: /*#__PURE__*/ _jsxs("button", {
                                    className: "dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                    onClick: function() {
                                        return dispatch(updateRenkingData(text));
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-jacarta-700 dark:text-white",
                                            children: text
                                        }),
                                        sortActive === id && /*#__PURE__*/ _jsxs("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "24",
                                            height: "24",
                                            className: "fill-accent mb-[3px] h-4 w-4",
                                            children: [
                                                /*#__PURE__*/ _jsx("path", {
                                                    fill: "none",
                                                    d: "M0 0h24v24H0z"
                                                }),
                                                /*#__PURE__*/ _jsx("path", {
                                                    d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, id);
                        })
                    })
                })
            ]
        });
    } else if (dropdownFor === "sale-type") {
        return /*#__PURE__*/ _jsxs("div", {
            className: "my-1 mr-2.5 relative",
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    className: "group dropdown-toggle dropdown-sale dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white",
                    onClick: handleSaleDropdown,
                    children: [
                        /*#__PURE__*/ _jsxs("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            className: "fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    fill: "none",
                                    d: "M0 0h24v24H0z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976zM13 10V5l-5 7h3v5l5-7h-3z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: "Sale type"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: dropdownSale ? "dropdown-menu dark:bg-jacarta-800 z-10 min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show absolute top-full right-0" : "dropdown-menu dark:bg-jacarta-800 z-10 hidden min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl absolute top-full right-0",
                    children: [
                        /*#__PURE__*/ _jsx("ul", {
                            className: "flex flex-col flex-wrap",
                            children: data.map(function(param) {
                                var id = param.id, text = param.text;
                                return /*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsxs("button", {
                                        className: "dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                        onClick: function() {
                                            return setsortActive(id);
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-jacarta-700 dark:text-white",
                                                children: text
                                            }),
                                            sortActive === id && /*#__PURE__*/ _jsxs("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 24 24",
                                                width: "24",
                                                height: "24",
                                                className: "fill-accent mb-[3px] h-4 w-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx("path", {
                                                        fill: "none",
                                                        d: "M0 0h24v24H0z"
                                                    }),
                                                    /*#__PURE__*/ _jsx("path", {
                                                        d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, id);
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "dark:border-jacarta-600 border-jacarta-100 -ml-2 -mr-2 mt-4 flex items-center justify-center space-x-3 border-t px-7 pt-4",
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "text-accent shadow-white-volume hover:bg-accent-dark hover:shadow-accent-volume flex-1 rounded-full bg-white py-2 px-6 text-center text-sm font-semibold transition-all hover:text-white",
                                    children: "Clear"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "bg-accent shadow-accent-volume hover:bg-accent-dark flex-1 rounded-full py-2 px-6 text-center text-sm font-semibold text-white transition-all",
                                    children: "Apply"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    } else if (dropdownFor === "price-range") {
        var currencyData = [
            {
                id: 1,
                image: "/images/chains/ETH.png",
                text: "ETH"
            },
            {
                id: 2,
                image: "/images/chains/FLOW.png",
                text: "FLOW"
            },
            {
                id: 3,
                image: "/images/chains/FUSD.png",
                text: "FUSD"
            },
            {
                id: 4,
                image: "/images/chains/XTZ.png",
                text: "XTZ"
            },
            {
                id: 5,
                image: "/images/chains/DAI.png",
                text: "DAI"
            },
            {
                id: 6,
                image: "/images/chains/RARI.png",
                text: "RARI"
            }, 
        ];
        return /*#__PURE__*/ _jsx("div", {
            className: "my-1 mr-2.5",
            children: /*#__PURE__*/ _jsx(Tippy, {
                animation: "fade",
                arrow: false,
                trigger: "click",
                interactive: "true",
                placement: "bottom",
                className: "tooltip-container",
                content: /*#__PURE__*/ _jsxs("div", {
                    className: "dropdown-menu dark:bg-jacarta-800 z-10 min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show",
                    "aria-labelledby": "priceRangeFilter",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "dropdown mb-4 cursor-pointer px-5 pt-2 relative",
                            children: [
                                /*#__PURE__*/ _jsxs("button", {
                                    className: "currency-dropdown dark:bg-jacarta-700 dropdown-toggle border-jacarta-100 dark:border-jacarta-600 flex items-center justify-between rounded-lg border py-3.5 px-3 text-sm dark:text-white w-full",
                                    onClick: handleCurrencyDropdown,
                                    children: [
                                        /*#__PURE__*/ _jsxs("span", {
                                            className: "font-display flex items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "/images/chains/ETH.png",
                                                    alt: "eth",
                                                    className: "mr-2 h-5 w-5 rounded-full"
                                                }),
                                                "ETH"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "24",
                                            height: "24",
                                            className: "fill-jacarta-500 h-4 w-4 dark:fill-white",
                                            children: [
                                                /*#__PURE__*/ _jsx("path", {
                                                    fill: "none",
                                                    d: "M0 0h24v24H0z"
                                                }),
                                                /*#__PURE__*/ _jsx("path", {
                                                    d: "M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: currencyDropdown ? "dark:bg-jacarta-800 z-10 min-w-[252px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show absolute top-full right-0" : "dark:bg-jacarta-800 z-10 min-w-[252px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl absolute top-full right-0 hidden",
                                    children: currencyData.map(function(param) {
                                        var id = param.id, text = param.text, image = param.image;
                                        return /*#__PURE__*/ _jsx("button", {
                                            className: "dropdown-item font-display text-jacarta-700 dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                            onClick: function() {
                                                return setCurrencyDropdown(false);
                                            },
                                            children: /*#__PURE__*/ _jsxs("span", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: image,
                                                        alt: "eth",
                                                        className: "mr-2 h-5 w-5 rounded-full"
                                                    }),
                                                    text
                                                ]
                                            })
                                        }, id);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center space-x-3 px-5 pb-2",
                            children: [
                                /*#__PURE__*/ _jsx("input", {
                                    type: "number",
                                    placeholder: "From",
                                    value: currencyValFrom,
                                    onChange: function(e) {
                                        return handleCurrencyValFrom(e);
                                    },
                                    className: "text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full max-w-[7.5rem] rounded-lg border py-[0.6875rem] px-4 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                                }),
                                /*#__PURE__*/ _jsx("input", {
                                    type: "number",
                                    placeholder: "To",
                                    value: currencyValTo,
                                    onChange: function(e) {
                                        return handleCurrencyValTo(e);
                                    },
                                    className: "text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full max-w-[7.5rem] rounded-lg border py-[0.6875rem] px-4 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "dark:border-jacarta-600 border-jacarta-100 -ml-2 -mr-2 mt-4 flex items-center justify-center space-x-3 border-t px-7 pt-4",
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "text-accent shadow-white-volume hover:bg-accent-dark hover:shadow-accent-volume flex-1 rounded-full bg-white py-2 px-6 text-center text-sm font-semibold transition-all hover:text-white",
                                    children: "Clear"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "bg-accent shadow-accent-volume hover:bg-accent-dark flex-1 rounded-full py-2 px-6 text-center text-sm font-semibold text-white transition-all",
                                    children: "Apply"
                                })
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ _jsxs("button", {
                    className: "group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white",
                    id: "priceRangeFilter",
                    "data-bs-toggle": "dropdown",
                    "data-bs-auto-close": "outside",
                    "aria-expanded": "false",
                    children: [
                        /*#__PURE__*/ _jsxs("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            className: "fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    fill: "none",
                                    d: "M0 0h24v24H0z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M17 16h2V4H9v2h8v10zm0 2v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.007-1H7V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3zM5.003 8L5 20h10V8H5.003zM7 16h4.5a.5.5 0 1 0 0-1h-3a2.5 2.5 0 1 1 0-5H9V9h2v1h2v2H8.5a.5.5 0 1 0 0 1h3a2.5 2.5 0 1 1 0 5H11v1H9v-1H7v-2z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: "Price Range"
                        })
                    ]
                })
            })
        });
    } else if (dropdownFor === "last7Days-ranks") {
        return /*#__PURE__*/ _jsxs("div", {
            className: "dropdown relative my-1 cursor-pointer",
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    className: "dark:bg-jacarta-700 itemDateDropdown dropdown-toggle border-jacarta-100 dark:border-jacarta-600 inline-flex w-48 items-center justify-between rounded-lg border bg-white py-2 px-3 text-sm dark:text-white",
                    onClick: handleItemDateDropdown,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "font-display",
                            children: "Last 7 Days"
                        }),
                        /*#__PURE__*/ _jsxs("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            className: "fill-jacarta-500 h-4 w-4 dark:fill-white",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    fill: "none",
                                    d: "M0 0h24v24H0z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: itemDateDropdown ? "dropdown-menu dark:bg-jacarta-800 z-10 whitespace-nowrap rounded-xl max-w-xs w-[13rem] bg-white py-4 px-2 text-left shadow-xl show absolute top-full right-0" : "dropdown-menu dark:bg-jacarta-800 z-10 whitespace-nowrap rounded-xl max-w-xs w-[13rem] bg-white py-4 px-2 text-left shadow-xl hidden absolute top-full right-0",
                    children: data.map(function(param) {
                        var id = param.id, text = param.text;
                        return /*#__PURE__*/ _jsxs("button", {
                            onClick: function() {
                                setsortActive(id);
                                dispatch(updateRenkingDataByPostdate(text));
                            },
                            className: "dropdown-item font-display text-jacarta-700 dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                            children: [
                                text,
                                sortActive === id && /*#__PURE__*/ _jsxs("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    width: "24",
                                    height: "24",
                                    className: "fill-accent mb-[3px] h-4 w-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("path", {
                                            fill: "none",
                                            d: "M0 0h24v24H0z"
                                        }),
                                        /*#__PURE__*/ _jsx("path", {
                                            d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                                        })
                                    ]
                                })
                            ]
                        }, id);
                    })
                })
            ]
        });
    }
};
/* harmony default export */ var recently_added_dropdown = ((/* unused pure expression or super */ null && (recently_added_dropdown_Recently_added_dropdown)));

;// CONCATENATED MODULE: ./components/categories/trending_categories_items.jsx









var trending_categories_items_Trending_categories_items = function() {
    var ref = useState(trendingCategoryData), itemdata = ref[0], setItemdata = ref[1];
    var dispatch = useDispatch();
    var trendingCategorySorText = useSelector(function(state) {
        return state.counter;
    }).trendingCategorySorText;
    var ref1 = useState(0), filterVal = ref1[0], setFilterVal = ref1[1];
    var handleFilter = function(category) {
        if (category !== "all") {
            setItemdata(trendingCategoryData.filter(function(item) {
                return item.category === category;
            }));
        } else {
            setItemdata(trendingCategoryData);
        }
    };
    var sortText = [
        {
            id: 1,
            text: "Recently Added"
        },
        {
            id: 2,
            text: "Price: Low to High"
        },
        {
            id: 3,
            text: "Price: high to low"
        },
        {
            id: 4,
            text: "Auction Ending Soon"
        }, 
    ];
    useEffect(function() {
        dispatch(updateTrendingCategoryItemData(itemdata.slice(0, 8)));
    }, [
        itemdata,
        dispatch
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-8 flex flex-wrap items-center justify-between",
                children: [
                    /*#__PURE__*/ _jsx("ul", {
                        className: "flex flex-wrap items-center",
                        children: tranding_category_filter.map(function(param) {
                            var id = param.id, svg = param.svg, text = param.text;
                            if (text === "all") {
                                return /*#__PURE__*/ _jsx("li", {
                                    className: "my-1 mr-2.5",
                                    children: /*#__PURE__*/ _jsx("button", {
                                        className: filterVal === id ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize" : "dark:border-jacarta-600 dark:bg-jacarta-900 dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize",
                                        onClick: function() {
                                            handleFilter(text);
                                            setFilterVal(id);
                                        },
                                        children: text
                                    })
                                }, id);
                            } else {
                                return /*#__PURE__*/ _jsx("li", {
                                    className: "my-1 mr-2.5",
                                    children: /*#__PURE__*/ _jsx("button", {
                                        onClick: function() {
                                            handleFilter(text);
                                            setFilterVal(id);
                                        },
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: filterVal === id ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize" : "dark:border-jacarta-600 dark:bg-jacarta-900 dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize",
                                            children: [
                                                /*#__PURE__*/ _jsx("svg", {
                                                    className: filterVal === id ? "icon mr-1 h-4 w-4 transition-colors fill-white" : "icon fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white",
                                                    children: /*#__PURE__*/ _jsx("use", {
                                                        xlinkHref: "/icons.svg#icon-".concat(svg)
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: text
                                                })
                                            ]
                                        })
                                    })
                                }, id);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Recently_added_dropdown, {
                        data: sortText,
                        dropdownFor: "recently_added"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CategoryItem, {})
        ]
    });
};
/* harmony default export */ var trending_categories_items = ((/* unused pure expression or super */ null && (trending_categories_items_Trending_categories_items)));

;// CONCATENATED MODULE: ./components/categories/tranding_categories.jsx

/* eslint-disable @next/next/no-img-element */ 



var Tranding_category = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "py-24",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container",
            children: [
                /*#__PURE__*/ _jsx(HeadLine, {
                    text: "Trending categories",
                    image: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/64/26a1.png",
                    classes: "font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white"
                }),
                /*#__PURE__*/ _jsx(Trending_categories_items, {})
            ]
        })
    });
};
/* harmony default export */ var tranding_categories = ((/* unused pure expression or super */ null && (Tranding_category)));

;// CONCATENATED MODULE: ./data/newseLatterData.js
var newseLatterData_newseLatterData = [
    {
        id: "1",
        icon: {
            parentBg: "#beaaf7",
            childBg: "rgb(131 88 255) ",
            svg: "icon-wallet"
        },
        title: [
            "Set",
            "up",
            "your",
            "wallet"
        ],
        text: "Once you've set up your wallet of choice, connect it to OpenSeaby clicking the NFT Marketplacein the topright corner."
    },
    {
        id: "2",
        icon: {
            parentBg: "#c4f2e3",
            childBg: "rgb(16 185 129)",
            svg: "icon-wallet"
        },
        title: [
            "Create",
            "Your",
            "Collection"
        ],
        text: "Click Create and set up your collection. Add social links, a description, profile & banner images, andset a secondary sales fee."
    },
    {
        id: "3",
        icon: {
            parentBg: "#cddffb",
            childBg: "rgb(66 138 248)",
            svg: "icon-gallery"
        },
        title: [
            "Add",
            "Your",
            "NFTs"
        ],
        text: "Upload your work (image, video, audio, or 3D art), add a title and description, and customize your NFTswith properties, stats."
    },
    {
        id: "4",
        icon: {
            parentBg: "#ffd0d0",
            childBg: "rgb(239 68 68)",
            svg: "icon-list"
        },
        title: [
            "List",
            "Them",
            "For",
            "Sale"
        ],
        text: "Choose between auctions, fixed-price listings, and declining-price listings. You choose how you want tosell your NFTs!"
    }, 
];


;// CONCATENATED MODULE: ./components/blog/newseLatter.jsx




var NewseLatter = function(param) {
    var _bgWhite = param.bgWhite, bgWhite = _bgWhite === void 0 ? true : _bgWhite;
    return /*#__PURE__*/ _jsxs("section", {
        className: "dark:bg-jacarta-800 relative py-24",
        children: [
            bgWhite && /*#__PURE__*/ _jsx("picture", {
                className: "pointer-events-none absolute inset-0 -z-10 dark:hidden",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: "/images/gradient_light.jpg",
                    alt: "gradient",
                    className: "h-full",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ _jsx(HeadLine, {
                        text: "Create and sell your NFTs",
                        classes: "font-display text-jacarta-700 mb-16 text-center text-3xl dark:text-white"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4",
                        children: newseLatterData.map(function(item) {
                            var id = item.id, icon = item.icon, title = item.title, text = item.text;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "text-center newseLatter-item",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-6 inline-flex rounded-full p-3",
                                        style: {
                                            backgroundColor: icon.parentBg
                                        },
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "inline-flex h-12 w-12 items-center justify-center rounded-full",
                                            style: {
                                                backgroundColor: icon.childBg
                                            },
                                            children: /*#__PURE__*/ _jsx("svg", {
                                                className: "icon icon-wallet h-5 w-5 fill-white",
                                                children: /*#__PURE__*/ _jsx("use", {
                                                    xlinkHref: "/icons.svg#".concat(icon.svg)
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("h3", {
                                        className: "font-display text-jacarta-700 mb-4 text-lg dark:text-white",
                                        children: [
                                            id,
                                            ". ",
                                            title
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "dark:text-jacarta-300",
                                        children: text
                                    })
                                ]
                            }, id);
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-jacarta-700 mx-auto mt-20 max-w-2xl text-center text-lg dark:text-white",
                        children: "Join our mailing list to stay in the loop with our newest feature releases, NFT drops, and tips and tricks for navigating Xhibiter"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mx-auto mt-7 max-w-md text-center",
                        children: /*#__PURE__*/ _jsxs("form", {
                            className: "relative",
                            onSubmit: function(e) {
                                return e.preventDefault();
                            },
                            children: [
                                /*#__PURE__*/ _jsx("input", {
                                    type: "email",
                                    placeholder: "Email address",
                                    className: "dark:bg-jacarta-700 dark:border-jacarta-600 focus:ring-accent border-jacarta-100 w-full rounded-full border py-3 px-4 dark:text-white dark:placeholder-white"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    className: "hover:bg-accent-dark font-display bg-accent absolute top-2 right-2 rounded-full px-6 py-2 text-sm text-white",
                                    children: "Subscribe"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var newseLatter = ((/* unused pure expression or super */ null && (NewseLatter)));

;// CONCATENATED MODULE: ./data/auctions_category_data.js
var auctions_category_data_auctions_category_data = [
    {
        id: "0Monkeyme#155",
        bigImage: "/images/products/item_8.jpg",
        creatorImage: "/images/avatars/creator_1.png",
        ownerImage: "/images/avatars/owner_1.png",
        price: "1.3 ETH",
        title: "Monkeyme#155",
        likes: "25",
        auction_timer: "000"
    },
    {
        id: "1Splendid Girl",
        bigImage: "/images/products/item_6.jpg",
        creatorImage: "/images/avatars/creator_4.png",
        ownerImage: "/images/avatars/owner_4.png",
        price: "10 ETH",
        title: "Splendid Girl",
        likes: "60",
        auction_timer: "000"
    },
    {
        id: "2Asuna #1649",
        bigImage: "/images/products/item_11.jpg",
        creatorImage: "/images/avatars/creator_8.png",
        ownerImage: "/images/avatars/owner_5.png",
        price: "0.8 ETH",
        title: "Asuna #1649",
        likes: "34",
        auction_timer: "000"
    },
    {
        id: "3Artof Eve",
        bigImage: "/images/products/item_10.jpg",
        creatorImage: "/images/avatars/creator_2.png",
        ownerImage: "/images/avatars/owner_7.png",
        price: "1.75 ETH",
        title: "Artof Eve",
        likes: "15",
        auction_timer: "550000000"
    },
    {
        id: "4Azuki #4017",
        bigImage: "/images/products/item_17.jpg",
        creatorImage: "/images/avatars/creator_2.png",
        ownerImage: "/images/avatars/owner_2.png",
        price: "9.3712 ETH",
        title: "Azuki #4017",
        likes: "334",
        auction_timer: "000"
    },
    {
        id: "5Block #2788",
        bigImage: "/images/products/item_18.jpg",
        creatorImage: "/images/avatars/creator_9.png",
        ownerImage: "/images/avatars/owner_8.png",
        price: "7.3 ETH",
        title: "Block #2788",
        likes: "52",
        auction_timer: "560000000"
    },
    {
        id: "6Crypto bull #6195",
        bigImage: "/images/products/item_19.jpg",
        creatorImage: "/images/avatars/creator_6.png",
        ownerImage: "/images/avatars/owner_4.png",
        price: "0.32 ETH",
        title: "Crypto bull #6195",
        likes: "90",
        auction_timer: "500000000"
    },
    {
        id: "7TSAR\xc9VNA",
        bigImage: "/images/products/item_20.jpg",
        creatorImage: "/images/avatars/creator_3.png",
        ownerImage: "/images/avatars/owner_3.png",
        price: "4.7 ETH",
        title: "TSAR\xc9VNA",
        likes: "260",
        auction_timer: "000"
    },
    {
        id: "8Monkeyme#155",
        bigImage: "/images/products/item_8.jpg",
        creatorImage: "/images/avatars/creator_1.png",
        ownerImage: "/images/avatars/owner_1.png",
        price: "1.3 ETH",
        title: "Monkeyme#155",
        likes: "25",
        auction_timer: "000"
    },
    {
        id: "9Splendid Girl",
        bigImage: "/images/products/item_6.jpg",
        creatorImage: "/images/avatars/creator_4.png",
        ownerImage: "/images/avatars/owner_4.png",
        price: "10 ETH",
        title: "Splendid Girl",
        likes: "60",
        auction_timer: "000"
    },
    {
        id: "10Asuna #1649",
        bigImage: "/images/products/item_11.jpg",
        creatorImage: "/images/avatars/creator_8.png",
        ownerImage: "/images/avatars/owner_5.png",
        price: "0.8 ETH",
        title: "Asuna #1649",
        likes: "34",
        auction_timer: "000"
    },
    {
        id: "11Artof Eve",
        bigImage: "/images/products/item_10.jpg",
        creatorImage: "/images/avatars/creator_2.png",
        ownerImage: "/images/avatars/owner_7.png",
        price: "1.75 ETH",
        title: "Artof Eve",
        likes: "15",
        auction_timer: "550000000"
    },
    {
        id: "12Azuki #4017",
        bigImage: "/images/products/item_17.jpg",
        creatorImage: "/images/avatars/creator_2.png",
        ownerImage: "/images/avatars/owner_2.png",
        price: "9.3712 ETH",
        title: "Azuki #4017",
        likes: "334",
        auction_timer: "000"
    },
    {
        id: "13Block #2788",
        bigImage: "/images/products/item_18.jpg",
        creatorImage: "/images/avatars/creator_9.png",
        ownerImage: "/images/avatars/owner_8.png",
        price: "7.3 ETH",
        title: "Block #2788",
        likes: "52",
        auction_timer: "560000000"
    },
    {
        id: "14Crypto bull #6195",
        bigImage: "/images/products/item_19.jpg",
        creatorImage: "/images/avatars/creator_6.png",
        ownerImage: "/images/avatars/owner_4.png",
        price: "0.32 ETH",
        title: "Crypto bull #6195",
        likes: "90",
        auction_timer: "500000000"
    },
    {
        id: "15TSAR\xc9VNA",
        bigImage: "/images/products/item_20.jpg",
        creatorImage: "/images/avatars/creator_3.png",
        ownerImage: "/images/avatars/owner_3.png",
        price: "4.7 ETH",
        title: "TSAR\xc9VNA",
        likes: "260",
        auction_timer: "000"
    }, 
];
/* harmony default export */ var data_auctions_category_data = ((/* unused pure expression or super */ null && (auctions_category_data_auctions_category_data)));

// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(8130);
;// CONCATENATED MODULE: ./components/Countdown_timer.jsx


var Completionist = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "text-2xs absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center justify-center space-x-1 rounded-full bg-white py-2.5 px-6 font-medium",
        children: /*#__PURE__*/ _jsx("span", {
            className: "js-countdown-timer text-jacarta-700 shrink-0 whitespace-nowrap",
            "data-countdown": "2022-05-14T10:45:30",
            "data-expired": "This auction has ended",
            children: "This auction has ended"
        })
    });
};
var renderer = function(param) {
    var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds, completed = param.completed;
    if (completed) {
        return /*#__PURE__*/ _jsx(Completionist, {});
    } else {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "text-2xs absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center justify-center space-x-1 rounded-full bg-white py-2.5 px-6 font-medium",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/64/23f3.png",
                        alt: "",
                        className: "h-3.5 w-3.5 shrink-0 bg-contain bg-center"
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "js-countdown-timer text-jacarta-700 shrink-0 whitespace-nowrap",
                        children: [
                            days,
                            " : ",
                            hours,
                            " : ",
                            minutes,
                            " : ",
                            seconds
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "js-countdown-left text-jacarta-700",
                        "data-countdownleft": "left",
                        children: "left"
                    })
                ]
            })
        });
    }
};
var Countdown_timer_Countdown_timer = function(param) {
    var time = param.time;
    return /*#__PURE__*/ _jsx(Countdown, {
        date: Date.now() + time,
        renderer: renderer
    });
};
/* harmony default export */ var components_Countdown_timer = ((/* unused pure expression or super */ null && (Countdown_timer_Countdown_timer)));

// EXTERNAL MODULE: ./node_modules/tippy.js/themes/light.css
var light = __webpack_require__(8364);
;// CONCATENATED MODULE: ./components/categories/Auctions_categories.jsx














var Auctions_categories = function() {
    var dispatch = useDispatch();
    var ref = useState(Auctions_category_data.slice(0, 8)), data = ref[0], setData = ref[1];
    var ref1 = useState(true), loadMoreBtn = ref1[0], setLoadMoreBtn = ref1[1];
    var handleloadMore = function() {
        setData(auctions_category_data);
        setLoadMoreBtn(false);
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("section", {
            className: "py-24",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ _jsx(HeadLine, {
                        image: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/64/2764-fe0f.png",
                        text: "Live Auctions",
                        classes: "font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4",
                        children: data.map(function(item) {
                            var id = item.id, bigImage = item.bigImage, creatorImage = item.creatorImage, ownerImage = item.ownerImage, title = item.title, price = item.price, likes = item.likes, auction_timer = item.auction_timer;
                            var itemLink = bigImage.split("/").slice(-1).toString().replace(".jpg", "").replace(".gif", "");
                            return /*#__PURE__*/ _jsx("article", {
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mb-4 flex items-center justify-between relative",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex -space-x-2 ",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Tippy, {
                                                            theme: "tomato",
                                                            content: /*#__PURE__*/ _jsx("span", {
                                                                className: "py-1 px-2 block",
                                                                children: "Creator: Sussygirl"
                                                            }),
                                                            children: /*#__PURE__*/ _jsx(Link, {
                                                                href: /item/ + itemLink,
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    children: /*#__PURE__*/ _jsx(Image, {
                                                                        src: creatorImage,
                                                                        alt: "creator",
                                                                        className: "h-6 w-6 rounded-full",
                                                                        height: 24,
                                                                        width: 24
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(Tippy, {
                                                            content: /*#__PURE__*/ _jsx("span", {
                                                                className: "py-1 px-2 block",
                                                                children: "Owner: Sussygirl"
                                                            }),
                                                            children: /*#__PURE__*/ _jsx(Link, {
                                                                href: /item/ + itemLink,
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    children: /*#__PURE__*/ _jsx(Image, {
                                                                        src: ownerImage,
                                                                        alt: "creator",
                                                                        className: "h-6 w-6 rounded-full",
                                                                        height: 24,
                                                                        width: 24
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Auctions_dropdown, {
                                                    classes: "dark:hover:bg-jacarta-600 dropdown hover:bg-jacarta-100 rounded-full "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("figure", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    href: /item/ + itemLink,
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        children: /*#__PURE__*/ _jsx(Image, {
                                                            src: bigImage,
                                                            alt: "item 8",
                                                            className: "w-full rounded-[0.625rem]",
                                                            loading: "lazy",
                                                            height: "100%",
                                                            width: "100%",
                                                            layout: "responsive",
                                                            objectFit: "cover"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Countdown_timer, {
                                                    time: +auction_timer
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mt-7 flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    href: /item/ + itemLink,
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: "font-display text-jacarta-700 hover:text-accent text-base dark:text-white",
                                                            children: title
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "dark:border-jacarta-600 border-jacarta-100 flex items-center whitespace-nowrap rounded-md border py-1 px-2",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: /*#__PURE__*/ _jsx(Tippy, {
                                                            content: /*#__PURE__*/ _jsx("span", {
                                                                className: "py-1 px-2 block",
                                                                children: "ETH"
                                                            }),
                                                            children: /*#__PURE__*/ _jsx("svg", {
                                                                className: "h-4 w-4",
                                                                children: /*#__PURE__*/ _jsx("use", {
                                                                    xlinkHref: "/icons.svg#icon-ETH"
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mt-2 text-sm",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "dark:text-jacarta-300",
                                                    children: "Highest Bid"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "dark:text-jacarta-100 text-jacarta-700",
                                                    children: price
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mt-8 flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    className: "text-accent font-display text-sm font-semibold",
                                                    onClick: function() {
                                                        return dispatch(bidsModalShow());
                                                    },
                                                    children: "Place bid"
                                                }),
                                                /*#__PURE__*/ _jsx(Likes, {
                                                    like: likes,
                                                    classes: "flex items-center space-x-1"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, id);
                        })
                    }),
                    loadMoreBtn && /*#__PURE__*/ _jsx("div", {
                        className: "mt-10 text-center",
                        children: /*#__PURE__*/ _jsx("button", {
                            onClick: handleloadMore,
                            className: "bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all",
                            children: "Load More"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var categories_Auctions_categories = ((/* unused pure expression or super */ null && (Auctions_categories)));

;// CONCATENATED MODULE: ./data/Feature_collections_data.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8, _obj9, _obj10, _obj11, _obj12;
var Feature_collections_data_Feature_collections_data = [
    (_obj = {
        id: "0Art Me Outside",
        bigImage: "/images/collections/collection_1_1.jpg",
        subImage1: "/images/collections/collection_1_2.jpg",
        subImage2: "/images/collections/collection_1_3.jpg",
        subImage3: "/images/collections/collection_1_4.jpg",
        userImage: "/images/avatars/owner_5.png",
        userName: "Wow Frens",
        itemsCount: "10K",
        title: "Art Me Outside",
        category: "art"
    }, _defineProperty(_obj, "category", "Collectibles"), _defineProperty(_obj, "category", "photography"), _defineProperty(_obj, "top", true), _defineProperty(_obj, "trending", true), _defineProperty(_obj, "recent", true), _obj),
    (_obj1 = {
        id: "1PankySkal",
        bigImage: "/images/collections/collection_2_1.jpg",
        subImage1: "/images/collections/collection_2_2.jpg",
        subImage2: "/images/collections/collection_2_3.jpg",
        subImage3: "/images/collections/collection_2_4.jpg",
        userImage: "/images/avatars/owner_9.png",
        userName: "NFT stars",
        itemsCount: "2.8K",
        title: "PankySkal",
        category: "Collectibles"
    }, _defineProperty(_obj1, "category", "photography"), _defineProperty(_obj1, "category", "music"), _defineProperty(_obj1, "top", false), _defineProperty(_obj1, "trending", false), _defineProperty(_obj1, "recent", false), _obj1),
    (_obj2 = {
        id: "2VR Space_287",
        bigImage: "/images/collections/collection_3_1.jpg",
        subImage1: "/images/collections/collection_3_2.jpg",
        subImage2: "/images/collections/collection_3_3.jpg",
        subImage3: "/images/collections/collection_3_4.jpg",
        userImage: "/images/avatars/owner_4.png",
        userName: "Origin Morish",
        itemsCount: "8K",
        title: "VR Space_287",
        category: "domain"
    }, _defineProperty(_obj2, "category", "photography"), _defineProperty(_obj2, "top", true), _defineProperty(_obj2, "trending", false), _defineProperty(_obj2, "recent", true), _obj2),
    (_obj3 = {
        id: "3Metasmorf",
        bigImage: "/images/collections/collection_4_1.jpg",
        subImage1: "/images/collections/collection_4_2.jpg",
        subImage2: "/images/collections/collection_4_3.jpg",
        subImage3: "/images/collections/collection_4_4.jpg",
        userImage: "/images/avatars/owner_10.png",
        userName: "Lazy Panda",
        itemsCount: "1.5K",
        title: "Metasmorf",
        category: "music"
    }, _defineProperty(_obj3, "category", "photography"), _defineProperty(_obj3, "category", "art"), _defineProperty(_obj3, "top", false), _defineProperty(_obj3, "trending", true), _defineProperty(_obj3, "recent", false), _obj3),
    (_obj4 = {
        id: "43Landers",
        bigImage: "/images/collections/collection_5_1.jpg",
        subImage1: "/images/collections/collection_5_2.jpg",
        subImage2: "/images/collections/collection_5_3.jpg",
        subImage3: "/images/collections/collection_5_4.jpg",
        userImage: "/images/avatars/owner_11.png",
        userName: "051_Hart",
        itemsCount: "15K",
        title: "3Landers",
        category: "photography"
    }, _defineProperty(_obj4, "category", "Collectibles"), _defineProperty(_obj4, "category", "music"), _defineProperty(_obj4, "top", true), _defineProperty(_obj4, "trending", false), _defineProperty(_obj4, "recent", true), _obj4),
    (_obj5 = {
        id: "5SlimHoods",
        bigImage: "/images/collections/collection_6_1.jpg",
        subImage1: "/images/collections/collection_6_2.jpg",
        subImage2: "/images/collections/collection_6_3.jpg",
        subImage3: "/images/collections/collection_6_4.jpg",
        userImage: "/images/avatars/owner_3.png",
        userName: "Crytopank",
        itemsCount: "8.8K",
        title: "SlimHoods",
        category: "virtual world"
    }, _defineProperty(_obj5, "category", "music"), _defineProperty(_obj5, "category", "art"), _defineProperty(_obj5, "top", true), _defineProperty(_obj5, "trending", true), _defineProperty(_obj5, "recent", false), _obj5),
    (_obj6 = {
        id: "6The Overseers",
        bigImage: "/images/collections/collection_7_1.jpg",
        subImage1: "/images/collections/collection_7_2.jpg",
        subImage2: "/images/collections/collection_7_3.jpg",
        subImage3: "/images/collections/collection_7_4.jpg",
        userImage: "/images/avatars/creator_2.png",
        userName: "Hey Mrsmeseks",
        itemsCount: "13K",
        title: "The Overseers",
        category: "art"
    }, _defineProperty(_obj6, "category", "Collectibles"), _defineProperty(_obj6, "top", false), _defineProperty(_obj6, "trending", true), _defineProperty(_obj6, "recent", true), _obj6),
    (_obj7 = {
        id: "7Dope Shibas",
        bigImage: "/images/collections/collection_8_1.jpg",
        subImage1: "/images/collections/collection_8_2.jpg",
        subImage2: "/images/collections/collection_8_3.jpg",
        subImage3: "/images/collections/collection_8_4.jpg",
        userImage: "/images/avatars/owner_12.png",
        userName: "alyxbow",
        itemsCount: "3K",
        title: "Dope Shibas",
        category: "Collectibles"
    }, _defineProperty(_obj7, "category", "art"), _defineProperty(_obj7, "top", true), _defineProperty(_obj7, "trending", false), _defineProperty(_obj7, "recent", true), _obj7),
    {
        id: "8Art Me Outside",
        bigImage: "/images/collections/collection_1_1.jpg",
        subImage1: "/images/collections/collection_1_2.jpg",
        subImage2: "/images/collections/collection_1_3.jpg",
        subImage3: "/images/collections/collection_1_4.jpg",
        userImage: "/images/avatars/owner_5.png",
        userName: "Wow Frens",
        itemsCount: "10K",
        title: "Art Me Outside",
        category: "art",
        top: true,
        trending: true,
        recent: false
    },
    {
        id: "9PankySkal",
        bigImage: "/images/collections/collection_2_1.jpg",
        subImage1: "/images/collections/collection_2_2.jpg",
        subImage2: "/images/collections/collection_2_3.jpg",
        subImage3: "/images/collections/collection_2_4.jpg",
        userImage: "/images/avatars/owner_9.png",
        userName: "NFT stars",
        itemsCount: "2.8K",
        title: "PankySkal",
        category: "Collectibles",
        top: false,
        trending: true,
        recent: true
    },
    (_obj8 = {
        id: "10VR Space_287",
        bigImage: "/images/collections/collection_3_1.jpg",
        subImage1: "/images/collections/collection_3_2.jpg",
        subImage2: "/images/collections/collection_3_3.jpg",
        subImage3: "/images/collections/collection_3_4.jpg",
        userImage: "/images/avatars/owner_4.png",
        userName: "Origin Morish",
        itemsCount: "8K",
        title: "VR Space_287",
        category: "domain"
    }, _defineProperty(_obj8, "category", "Collectibles"), _defineProperty(_obj8, "top", true), _defineProperty(_obj8, "trending", false), _defineProperty(_obj8, "recent", true), _obj8),
    (_obj9 = {
        id: "11Metasmorf",
        bigImage: "/images/collections/collection_4_1.jpg",
        subImage1: "/images/collections/collection_4_2.jpg",
        subImage2: "/images/collections/collection_4_3.jpg",
        subImage3: "/images/collections/collection_4_4.jpg",
        userImage: "/images/avatars/owner_10.png",
        userName: "Lazy Panda",
        itemsCount: "1.5K",
        title: "Metasmorf",
        category: "music"
    }, _defineProperty(_obj9, "category", "Collectibles"), _defineProperty(_obj9, "category", "virtual world"), _defineProperty(_obj9, "top", true), _defineProperty(_obj9, "trending", true), _defineProperty(_obj9, "recent", false), _obj9),
    (_obj10 = {
        id: "123Landers",
        bigImage: "/images/collections/collection_5_1.jpg",
        subImage1: "/images/collections/collection_5_2.jpg",
        subImage2: "/images/collections/collection_5_3.jpg",
        subImage3: "/images/collections/collection_5_4.jpg",
        userImage: "/images/avatars/owner_11.png",
        userName: "051_Hart",
        itemsCount: "15K",
        title: "3Landers",
        category: "photography"
    }, _defineProperty(_obj10, "category", "domain"), _defineProperty(_obj10, "category", "virtual world"), _defineProperty(_obj10, "top", false), _defineProperty(_obj10, "trending", true), _defineProperty(_obj10, "recent", true), _obj10),
    (_obj11 = {
        id: "13SlimHoods",
        bigImage: "/images/collections/collection_6_1.jpg",
        subImage1: "/images/collections/collection_6_2.jpg",
        subImage2: "/images/collections/collection_6_3.jpg",
        subImage3: "/images/collections/collection_6_4.jpg",
        userImage: "/images/avatars/owner_3.png",
        userName: "Crytopank",
        itemsCount: "8.8K",
        title: "SlimHoods",
        category: "virtual world"
    }, _defineProperty(_obj11, "category", "domain"), _defineProperty(_obj11, "top", true), _defineProperty(_obj11, "trending", false), _defineProperty(_obj11, "recent", true), _obj11),
    (_obj12 = {
        id: "14The Overseers",
        bigImage: "/images/collections/collection_7_1.jpg",
        subImage1: "/images/collections/collection_7_2.jpg",
        subImage2: "/images/collections/collection_7_3.jpg",
        subImage3: "/images/collections/collection_7_4.jpg",
        userImage: "/images/avatars/creator_2.png",
        userName: "Hey Mrsmeseks",
        itemsCount: "13K",
        title: "The Overseers",
        category: "domain"
    }, _defineProperty(_obj12, "category", "virtual world"), _defineProperty(_obj12, "top", true), _defineProperty(_obj12, "trending", true), _defineProperty(_obj12, "recent", false), _obj12), 
];
/* harmony default export */ var data_Feature_collections_data = ((/* unused pure expression or super */ null && (Feature_collections_data_Feature_collections_data)));

;// CONCATENATED MODULE: ./components/carousel/Feature_collection_carousel.jsx










var Feature_collection_carousel_Feature_collections_carousel = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Swiper, {
                modules: [
                    Navigation,
                    Pagination,
                    Scrollbar
                ],
                breakpoints: {
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1100: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    }
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                className: " card-slider-4-columns !py-5",
                children: Feature_collections_data.map(function(item) {
                    var id = item.id, bigImage = item.bigImage, subImage1 = item.subImage1, subImage2 = item.subImage2, subImage3 = item.subImage3, userImage = item.userImage, title = item.title, itemsCount = item.itemsCount, userName = item.userName;
                    var itemLink = bigImage.split("/").slice(-1).toString().split("_").slice(1, 2).toString();
                    return /*#__PURE__*/ _jsx(SwiperSlide, {
                        children: /*#__PURE__*/ _jsx("article", {
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg",
                                children: [
                                    /*#__PURE__*/ _jsx(Link, {
                                        href: "/item/item_".concat(itemLink),
                                        children: /*#__PURE__*/ _jsxs("a", {
                                            className: "flex space-x-[0.625rem]",
                                            children: [
                                                /*#__PURE__*/ _jsx("figure", {
                                                    className: "w-[74.5%] h-full",
                                                    children: /*#__PURE__*/ _jsx(Image, {
                                                        src: bigImage,
                                                        alt: "item 1",
                                                        className: "rounded-[0.625rem]",
                                                        width: 150,
                                                        height: 240,
                                                        objectFit: "cover",
                                                        layout: "responsive"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "flex w-1/3 flex-col space-y-[0.625rem]",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("img", {
                                                            src: subImage1,
                                                            alt: "item 1",
                                                            className: "h-full rounded-[0.625rem] object-cover",
                                                            loading: "lazy"
                                                        }),
                                                        /*#__PURE__*/ _jsx("img", {
                                                            src: subImage2,
                                                            alt: "item 1",
                                                            className: "h-full rounded-[0.625rem] object-cover",
                                                            loading: "lazy"
                                                        }),
                                                        /*#__PURE__*/ _jsx("img", {
                                                            src: subImage3,
                                                            alt: "item 1",
                                                            className: "h-full rounded-[0.625rem] object-cover",
                                                            loading: "lazy"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Link, {
                                        href: "/item/item_".concat(itemLink),
                                        children: /*#__PURE__*/ _jsx("a", {
                                            className: "font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white",
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mt-2 flex items-center justify-between text-sm font-medium tracking-tight",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-wrap items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Link, {
                                                        href: "/item/item_".concat(itemLink),
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            className: "mr-2 shrink-0",
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: userImage,
                                                                alt: "owner",
                                                                className: "h-5 w-5 rounded-full"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "dark:text-jacarta-400 mr-1",
                                                        children: "by"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Link, {
                                                        href: "/item/item_".concat(itemLink),
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            className: "text-accent",
                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                children: userName
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "dark:text-jacarta-300 text-sm",
                                                children: [
                                                    itemsCount,
                                                    " Items"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, id);
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "group swiper-button-prev shadow-white-volume absolute !top-1/2 !-left-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-jacarta-700 text-xl sm:!-left-6 after:hidden",
                children: /*#__PURE__*/ _jsx(MdKeyboardArrowLeft, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "group swiper-button-next shadow-white-volume absolute !top-1/2 !-right-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-jacarta-700 text-xl sm:!-right-6 after:hidden",
                children: /*#__PURE__*/ _jsx(MdKeyboardArrowRight, {})
            })
        ]
    });
};
/* harmony default export */ var Feature_collection_carousel = ((/* unused pure expression or super */ null && (Feature_collection_carousel_Feature_collections_carousel)));

;// CONCATENATED MODULE: ./components/collectrions/Feature_collections.jsx





var Feature_collections = function(param) {
    var _bgWhite = param.bgWhite, bgWhite = _bgWhite === void 0 ? false : _bgWhite;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("section", {
            className: "py-24 relative",
            children: [
                bgWhite && /*#__PURE__*/ _jsx("picture", {
                    className: "pointer-events-none absolute inset-0 -z-10 dark:hidden",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/images/gradient_light.jpg",
                        alt: "gradient",
                        className: "h-full",
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ _jsx(HeadLine, {
                            image: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/64/1f4a5.png",
                            text: "Featured collections",
                            classes: "font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "relative",
                            children: /*#__PURE__*/ _jsx(Feature_collections_carousel, {})
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var collectrions_Feature_collections = ((/* unused pure expression or super */ null && (Feature_collections)));

// EXTERNAL MODULE: ./components/partners/Partners.jsx
var Partners = __webpack_require__(846);
;// CONCATENATED MODULE: ./data/Browse_category_data.js
var Browse_category_data_Browse_category_data = [
    {
        id: "0Virtual Worlds",
        image: "/images/categories/category_4.png",
        title: "Virtual Worlds",
        href: "#",
        bgColor: "rgb(70 199 227)"
    },
    {
        id: "1Sport",
        image: "/images/categories/category_5.png",
        title: "Sport",
        href: "#",
        bgColor: "rgb(115 126 242)"
    },
    {
        id: "2Photography",
        image: "/images/categories/category_6.png",
        title: "Photography",
        href: "#",
        bgColor: "rgb(66 138 248)"
    },
    {
        id: "3Music",
        image: "/images/categories/category_7.png",
        title: "Music",
        href: "#",
        bgColor: "rgb(243 91 199)"
    },
    {
        id: "4Art",
        image: "/images/categories/category_1.png",
        title: "Art",
        href: "#",
        bgColor: "rgb(16 185 129)"
    },
    {
        id: "5Collectibles",
        image: "/images/categories/category_2.png",
        title: "Collectibles",
        href: "#",
        bgColor: "rgb(254 178 64)"
    },
    {
        id: "6Domain Names",
        image: "/images/categories/category_3.png",
        title: "Domain Names",
        href: "#",
        bgColor: "rgb(131 88 255)"
    },
    {
        id: "7Virtual Worlds",
        image: "/images/categories/category_4.png",
        title: "Virtual Worlds",
        href: "#",
        bgColor: "rgb(70 199 227)"
    },
    {
        id: "8Sport",
        image: "/images/categories/category_5.png",
        title: "Sport",
        href: "#",
        bgColor: "#737EF2"
    },
    {
        id: "9Photography",
        image: "/images/categories/category_6.png",
        title: "Photography",
        href: "#",
        bgColor: "rgb(66 138 248)"
    },
    {
        id: "10Music",
        image: "/images/categories/category_7.png",
        title: "Music",
        href: "#",
        bgColor: "#F35BC7"
    },
    {
        id: "11Art",
        image: "/images/categories/category_1.png",
        title: "Art",
        href: "#",
        bgColor: "rgb(16 185 129)"
    },
    {
        id: "12Virtual Worlds",
        image: "/images/categories/category_4.png",
        title: "Virtual Worlds",
        href: "#",
        bgColor: "#46C7E3"
    },
    {
        id: "13Domain Names",
        image: "/images/categories/category_3.png",
        title: "Domain Names",
        href: "#",
        bgColor: "rgb(131 88 255)"
    },
    {
        id: "14Collectibles",
        image: "/images/categories/category_2.png",
        title: "Collectibles",
        href: "#",
        bgColor: "rgb(254 178 64)"
    }, 
];
/* harmony default export */ var data_Browse_category_data = ((/* unused pure expression or super */ null && (Browse_category_data_Browse_category_data)));

;// CONCATENATED MODULE: ./components/carousel/Browse_category_carousel.jsx








var Browse_category_carousel_Browse_category_carousel = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "overflow-hidden",
        children: /*#__PURE__*/ _jsx(Swiper, {
            slidesPerView: "auto",
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                // when window width is >= 640px
                100: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                // when window width is >= 768px
                700: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                900: {
                    slidesPerView: 5,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 7,
                    spaceBetween: 30
                }
            },
            className: " card-slider-4-columns !py-5",
            style: {
                transform: "scaleX(1.2)"
            },
            children: Browse_category_data.map(function(item) {
                var id = item.id, image = item.image, title = item.title, bgColor = item.bgColor;
                return /*#__PURE__*/ _jsx(SwiperSlide, {
                    children: /*#__PURE__*/ _jsx("article", {
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: "/collection/explore_collection",
                            children: /*#__PURE__*/ _jsxs("a", {
                                className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg",
                                children: [
                                    /*#__PURE__*/ _jsx("figure", {
                                        style: {
                                            backgroundColor: bgColor
                                        },
                                        className: " rounded-t-[0.625rem] w-full rounded-[0.625rem",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: image,
                                            alt: "item 1",
                                            className: "w-full"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mt-4 text-center",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "font-display text-jacarta-700 text-lg dark:text-white",
                                            children: title
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }, id);
            })
        })
    });
};
/* harmony default export */ var carousel_Browse_category_carousel = ((/* unused pure expression or super */ null && (Browse_category_carousel_Browse_category_carousel)));

;// CONCATENATED MODULE: ./components/categories/Browse_category.jsx





var Browse_category = function(param) {
    var bgWhite = param.bgWhite;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("section", {
            className: bgWhite ? "pt-24 pb-16 relative" : "py-24 relative",
            children: [
                bgWhite && /*#__PURE__*/ _jsx("picture", {
                    className: "pointer-events-none absolute inset-0 -z-10 dark:hidden",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/images/gradient_light.jpg",
                        alt: "gradient",
                        className: "h-full",
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ _jsx(HeadLine, {
                    text: "Browse by category",
                    classes: "font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "relative",
                    children: /*#__PURE__*/ _jsx(Browse_category_carousel, {})
                })
            ]
        })
    });
};
/* harmony default export */ var categories_Browse_category = ((/* unused pure expression or super */ null && (Browse_category)));

;// CONCATENATED MODULE: ./data/hero_3_swiper_data.js
var hero_3_swiper_data_hero_3_swiper_data = [
    {
        id: "0Palettes of Aotearoa - The Place of greenstone #01",
        image: "/images/hero/hero_slide_1.jpg",
        title: "Palettes of Aotearoa - The Place of greenstone #01",
        name: "LeeCookNZ",
        titleLink: "#",
        userLink: "#"
    },
    {
        id: "1Portrait Gallery",
        image: "/images/hero/hero_slide_2.jpg",
        title: "Portrait Gallery",
        name: "By 051_Hart",
        titleLink: "#",
        userLink: "#"
    },
    {
        id: "2Oceania \\\\ OVERSEER 017",
        image: "/images/hero/hero_slide_3.jpg",
        title: "Oceania \\\\ OVERSEER 017",
        name: "By THE OVERSEERS",
        titleLink: "#",
        userLink: "#"
    },
    {
        id: "3Shiba #368",
        image: "/images/hero/hero_slide_4.jpg",
        title: "Shiba #368",
        name: "Generous Shiba Club",
        titleLink: "#",
        userLink: "#"
    },
    {
        id: "4Palettes of Aotearoa - The Place of greenstone #01",
        image: "/images/hero/hero_slide_1.jpg",
        title: "Palettes of Aotearoa - The Place of greenstone #01",
        name: "LeeCookNZ",
        titleLink: "#",
        userLink: "#"
    },
    {
        id: "5Portrait Gallery",
        image: "/images/hero/hero_slide_2.jpg",
        title: "Portrait Gallery",
        name: "By 051_Hart",
        titleLink: "#",
        userLink: "#"
    }, 
];
var hero_3_swiper_data_hero_3_swiper_thumbs_data = [
    {
        id: "0/images/hero/hero_slide_1_thumb.jpg",
        image: "/images/hero/hero_slide_1_thumb.jpg"
    },
    {
        id: "1/images/hero/hero_slide_2_thumb.jpg",
        image: "/images/hero/hero_slide_2_thumb.jpg"
    },
    {
        id: "2/images/hero/hero_slide_3_thumb.jpg",
        image: "/images/hero/hero_slide_3_thumb.jpg"
    },
    {
        id: "3/images/hero/hero_slide_4_thumb.jpg",
        image: "/images/hero/hero_slide_4_thumb.jpg"
    },
    {
        id: "4/images/hero/hero_slide_1_thumb.jpg",
        image: "/images/hero/hero_slide_1_thumb.jpg"
    },
    {
        id: "5/images/hero/hero_slide_4_thumb.jpg",
        image: "/images/hero/hero_slide_4_thumb.jpg"
    }, 
];


// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(4747);
// EXTERNAL MODULE: ./node_modules/swiper/modules/thumbs/thumbs.min.css
var thumbs_min = __webpack_require__(5236);
;// CONCATENATED MODULE: ./components/hero/hero_3.jsx







// Import Swiper styles




var Hero_3 = function() {
    var ref = useState(null), activeThumb = ref[0], setActiveThumb = ref[1];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("section", {
            className: "relative h-screen",
            children: [
                /*#__PURE__*/ _jsx(Swiper, {
                    modules: [
                        FreeMode,
                        Navigation,
                        Thumbs,
                        Autoplay
                    ],
                    loop: true,
                    spaceBetween: 10,
                    navigation: true,
                    thumbs: {
                        swiper: activeThumb && !activeThumb.destroyed ? activeThumb : null
                    },
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    className: "full-slider h-screen",
                    children: hero_3_swiper_data.map(function(item) {
                        var image = item.image, id = item.id, title = item.title, name = item.name, titleLink = item.titleLink, userLink = item.userLink;
                        return /*#__PURE__*/ _jsx(SwiperSlide, {
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "swiper-slide after:bg-jacarta-900/60 after:absolute after:inset-0",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "container relative z-10 h-full pt-40",
                                        children: [
                                            /*#__PURE__*/ _jsx("h2", {
                                                className: "font-display text-2xl font-semibold text-white",
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: titleLink,
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        children: title
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Link, {
                                                href: userLink,
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    className: "text-2xs font-medium text-white",
                                                    children: name
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: image,
                                        className: "absolute inset-0 h-full w-full object-cover",
                                        alt: title,
                                        layout: "fill"
                                    })
                                ]
                            })
                        }, id);
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "absolute inset-x-0 bottom-12",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "container",
                        children: /*#__PURE__*/ _jsx(Swiper, {
                            modules: [
                                FreeMode,
                                Navigation,
                                Thumbs
                            ],
                            onSwiper: setActiveThumb,
                            loop: true,
                            spaceBetween: 10,
                            slidesPerView: "auto",
                            breakpoints: {
                                100: {
                                    slidesPerView: 2
                                },
                                768: {
                                    slidesPerView: 3
                                }
                            },
                            className: " full-slider-thumbs swiper-initialized swiper-horizontal swiper-pointer-events swiper-thumbs",
                            children: hero_3_swiper_thumbs_data.map(function(item) {
                                var image = item.image, id = item.id;
                                return /*#__PURE__*/ _jsxs(SwiperSlide, {
                                    className: "swiper-slide cursor-pointer rounded p-5 swiper-slide-duplicate swiper-slide-duplicate-next ",
                                    children: [
                                        /*#__PURE__*/ _jsx("img", {
                                            src: image,
                                            className: "w-full rounded-lg",
                                            alt: "thumb 1"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "carousel-progress relative -bottom-5 z-10 -ml-5 -mr-5 h-0.5 bg-white/20 ",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "progress bg-accent absolute h-0.5 w-0"
                                            })
                                        })
                                    ]
                                }, id);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_3 = ((/* unused pure expression or super */ null && (Hero_3)));

// EXTERNAL MODULE: ./node_modules/react-tabs/esm/index.js + 9 modules
var esm = __webpack_require__(776);
;// CONCATENATED MODULE: ./data/items_tabs_data.js
var items_tabs_data_items_offer_data = [
    {
        id: "1ViviGiallo",
        ethPrice: "30",
        usdPrice: "$90,136.10",
        difference: "70%",
        Expiration: "5",
        user: "ViviGiallo"
    },
    {
        id: "2DB96DB",
        ethPrice: "15.5",
        usdPrice: "$45,458.10",
        difference: "70%",
        Expiration: "5",
        user: "DB96DB"
    },
    {
        id: "3myc_nc",
        ethPrice: "0.9",
        usdPrice: "$2,347.90",
        difference: "98%",
        Expiration: "5",
        user: "myc_nc"
    },
    {
        id: "4MetaRDnA",
        ethPrice: "1.2",
        usdPrice: "$4,568.40",
        difference: "100%",
        Expiration: "6",
        user: "MetaRDnA"
    },
    {
        id: "5Karafuru",
        ethPrice: "0.5",
        usdPrice: "$1,699.10",
        difference: "100%",
        Expiration: "6",
        user: "Karafuru"
    },
    {
        id: "6seekortelur",
        ethPrice: "4.7",
        usdPrice: "$13,966.64",
        difference: "40%",
        Expiration: "2",
        user: "seekortelur"
    }, 
];
var items_tabs_data_items_Properties_data = [
    {
        id: 0,
        category: "ACCESSORY",
        product: "Metal headband",
        trait: "3% have this trait"
    },
    {
        id: 1,
        category: "SKIN",
        product: "Dark Brown",
        trait: "8% have this trait"
    },
    {
        id: 2,
        category: "EYES",
        product: "Cyborg",
        trait: "2% have this trait"
    },
    {
        id: 3,
        category: "CLOTH",
        product: "Adidas",
        trait: "7% have this trait"
    },
    {
        id: 4,
        category: "HAIR",
        product: "White Ash",
        trait: "7% have this trait"
    },
    {
        id: 5,
        category: "CHARACTER",
        product: "TSAREVNA",
        trait: "1% have this trait"
    },
    {
        id: 6,
        category: "BACKGROUND",
        product: "CyberPunk",
        trait: "9% have this trait"
    },
    {
        id: 7,
        category: "MOUTH",
        product: "Flower",
        trait: "4% have this trait"
    }, 
];
var items_tabs_data_items_activity_data = [
    {
        id: "1ViviGiallo",
        price: "30",
        from: "AD496A",
        to: "Polymorph: MORPH Token",
        date: "19 days ago",
        text: "bid"
    },
    {
        id: "2DB96DB",
        price: ".00510",
        from: "The_vikk",
        to: "Polymorph: MORPH Token",
        date: "16 days ago",
        text: "transfer"
    },
    {
        id: "3myc_nc",
        price: "1.50",
        from: "CryptoGuysNFT",
        to: "Polymorph: MORPH Token",
        date: "19 days ago",
        text: "sale"
    }, 
];


;// CONCATENATED MODULE: ./components/tabs/OfferTab.jsx




var OfferTab_OfferTab = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "tab-pane fade show active",
            id: "offers",
            role: "tabpanel",
            "aria-labelledby": "offers-tab",
            children: /*#__PURE__*/ _jsxs("div", {
                role: "table",
                className: "scrollbar-custom dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 grid max-h-72 w-full grid-cols-5 overflow-y-auto rounded-lg rounded-tl-none border bg-white text-sm dark:text-white",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "contents",
                        role: "row",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "Price"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "USD Price"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "Floor Difference"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "Expiration"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "From"
                                })
                            })
                        ]
                    }),
                    items_offer_data.map(function(item) {
                        var ethPrice = item.ethPrice, id = item.id, usdPrice = item.usdPrice, difference = item.difference, Expiration = item.Expiration, user = item.user;
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "contents",
                            role: "row",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "dark:border-jacarta-600 border-jacarta-100 flex items-center whitespace-nowrap border-t py-4 px-4",
                                    role: "cell",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "-ml-1",
                                            "data-tippy-content": "ETH",
                                            children: /*#__PURE__*/ _jsx("svg", {
                                                className: "icon mr-1 h-4 w-4",
                                                children: /*#__PURE__*/ _jsx("use", {
                                                    xlinkHref: "/icons.svg#icon-ETH"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("span", {
                                            className: "text-green text-sm font-medium tracking-tight",
                                            children: [
                                                ethPrice,
                                                " ETH"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "dark:border-jacarta-600 border-jacarta-100 flex items-center border-t py-4 px-4",
                                    role: "cell",
                                    children: usdPrice
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "dark:border-jacarta-600 border-jacarta-100 flex items-center border-t py-4 px-4",
                                    role: "cell",
                                    children: [
                                        difference,
                                        " below"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "dark:border-jacarta-600 border-jacarta-100 flex items-center border-t py-4 px-4",
                                    role: "cell",
                                    children: [
                                        "in ",
                                        Expiration,
                                        " months"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "dark:border-jacarta-600 border-jacarta-100 flex items-center border-t py-4 px-4",
                                    role: "cell",
                                    children: /*#__PURE__*/ _jsx(Link, {
                                        href: "#",
                                        children: /*#__PURE__*/ _jsx("a", {
                                            className: "text-accent",
                                            children: user
                                        })
                                    })
                                })
                            ]
                        }, id);
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var tabs_OfferTab = ((/* unused pure expression or super */ null && (OfferTab_OfferTab)));

;// CONCATENATED MODULE: ./components/tabs/Properties.jsx




var Properties_Properties = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "tab-pane fade",
            id: "properties",
            role: "tabpanel",
            "aria-labelledby": "properties-tab",
            children: /*#__PURE__*/ _jsx("div", {
                className: "dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-t-2lg rounded-b-2lg rounded-tl-none border bg-white p-6 md:p-10",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4",
                    children: items_Properties_data.map(function(item) {
                        var id = item.id, category = item.category, product = item.product, trait = item.trait;
                        return /*#__PURE__*/ _jsx(Link, {
                            href: "#",
                            children: /*#__PURE__*/ _jsxs("a", {
                                className: "dark:bg-jacarta-800 dark:border-jacarta-600 bg-light-base rounded-2lg border-jacarta-100 flex flex-col space-y-2 border p-5 text-center transition-shadow hover:shadow-lg",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-accent text-sm uppercase",
                                        children: category
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-jacarta-700 text-base dark:text-white",
                                        children: product
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-jacarta-400 text-sm",
                                        children: trait
                                    })
                                ]
                            })
                        }, id);
                    })
                })
            })
        })
    });
};
/* harmony default export */ var tabs_Properties = ((/* unused pure expression or super */ null && (Properties_Properties)));

;// CONCATENATED MODULE: ./components/tabs/Activity_tab.jsx




var Activity_tab_Activity_tab = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "tab-pane fade",
            id: "activity",
            role: "tabpanel",
            "aria-labelledby": "activity-tab",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 bg-light-base border border-b-0 px-4 pt-5 pb-2.5",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-wrap",
                        children: [
                            /*#__PURE__*/ _jsxs("button", {
                                className: "dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-white px-4 py-3 hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent",
                                children: [
                                    /*#__PURE__*/ _jsxs("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 24 24",
                                        width: "24",
                                        height: "24",
                                        className: "fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white",
                                        children: [
                                            /*#__PURE__*/ _jsx("path", {
                                                fill: "none",
                                                d: "M0 0h24v24H0z"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M10.9 2.1l9.899 1.415 1.414 9.9-9.192 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414L10.9 2.1zm.707 2.122L3.828 12l8.486 8.485 7.778-7.778-1.06-7.425-7.425-1.06zm2.12 6.364a2 2 0 1 1 2.83-2.829 2 2 0 0 1-2.83 2.829z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-2xs font-medium",
                                        children: "Listing"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                className: "dark:hover:bg-accent-dark hover:bg-accent-dark bg-accent mr-2.5 mb-2.5 inline-flex items-center rounded-xl border border-transparent px-4 py-3",
                                children: [
                                    /*#__PURE__*/ _jsxs("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 24 24",
                                        width: "24",
                                        height: "24",
                                        className: "mr-2 h-4 w-4 fill-white",
                                        children: [
                                            /*#__PURE__*/ _jsx("path", {
                                                fill: "none",
                                                d: "M0 0h24v24H0z"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M14 20v2H2v-2h12zM14.586.686l7.778 7.778L20.95 9.88l-1.06-.354L17.413 12l5.657 5.657-1.414 1.414L16 13.414l-2.404 2.404.283 1.132-1.415 1.414-7.778-7.778 1.415-1.414 1.13.282 6.294-6.293-.353-1.06L14.586.686zm.707 3.536l-7.071 7.07 3.535 3.536 7.071-7.07-3.535-3.536z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-2xs font-medium text-white",
                                        children: "Bids"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                className: "dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-white px-4 py-3 hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent",
                                children: [
                                    /*#__PURE__*/ _jsxs("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 24 24",
                                        width: "24",
                                        height: "24",
                                        className: "fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white",
                                        children: [
                                            /*#__PURE__*/ _jsx("path", {
                                                fill: "none",
                                                d: "M0 0h24v24H0z"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M16.05 12.05L21 17l-4.95 4.95-1.414-1.414 2.536-2.537L4 18v-2h13.172l-2.536-2.536 1.414-1.414zm-8.1-10l1.414 1.414L6.828 6 20 6v2H6.828l2.536 2.536L7.95 11.95 3 7l4.95-4.95z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-2xs font-medium",
                                        children: "Transfers"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                className: "dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-white px-4 py-3 hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent",
                                children: [
                                    /*#__PURE__*/ _jsxs("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 24 24",
                                        width: "24",
                                        height: "24",
                                        className: "fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white",
                                        children: [
                                            /*#__PURE__*/ _jsx("path", {
                                                fill: "none",
                                                d: "M0 0h24v24H0z"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M6.5 2h11a1 1 0 0 1 .8.4L21 6v15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4zM19 8H5v12h14V8zm-.5-2L17 4H7L5.5 6h13zM9 10v2a3 3 0 0 0 6 0v-2h2v2a5 5 0 0 1-10 0v-2h2z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-2xs font-medium",
                                        children: "Sales"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    role: "table",
                    className: "scrollbar-custom dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 max-h-72 w-full overflow-y-auto rounded-lg rounded-tl-none border bg-white text-sm dark:text-white",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "dark:bg-jacarta-600 bg-light-base sticky top-0 flex",
                            role: "row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-[17%] py-2 px-4",
                                    role: "columnheader",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                        children: "Event"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-[17%] py-2 px-4",
                                    role: "columnheader",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                        children: "Price"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-[22%] py-2 px-4",
                                    role: "columnheader",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                        children: "From"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-[22%] py-2 px-4",
                                    role: "columnheader",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                        children: "To"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-[22%] py-2 px-4",
                                    role: "columnheader",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                        children: "Date"
                                    })
                                })
                            ]
                        }),
                        items_activity_data.map(function(item) {
                            var id = item.id, price = item.price, from = item.from, to = item.to, text = item.text, date = item.date;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "flex",
                                role: "row",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "dark:border-jacarta-600 border-jacarta-100 flex w-[17%] items-center border-t py-4 px-4",
                                        role: "cell",
                                        children: [
                                            /*#__PURE__*/ _jsxs("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 24 24",
                                                width: "24",
                                                height: "24",
                                                className: "fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white",
                                                children: [
                                                    /*#__PURE__*/ _jsx("path", {
                                                        fill: "none",
                                                        d: "M0 0h24v24H0z"
                                                    }),
                                                    /*#__PURE__*/ _jsx("path", {
                                                        d: "M14 20v2H2v-2h12zM14.586.686l7.778 7.778L20.95 9.88l-1.06-.354L17.413 12l5.657 5.657-1.414 1.414L16 13.414l-2.404 2.404.283 1.132-1.415 1.414-7.778-7.778 1.415-1.414 1.13.282 6.294-6.293-.353-1.06L14.586.686zm.707 3.536l-7.071 7.07 3.535 3.536 7.071-7.07-3.535-3.536z"
                                                    })
                                                ]
                                            }),
                                            text
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "dark:border-jacarta-600 border-jacarta-100 flex w-[17%] items-center whitespace-nowrap border-t py-4 px-4",
                                        role: "cell",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "-ml-1",
                                                "data-tippy-content": "ETH",
                                                children: /*#__PURE__*/ _jsx("svg", {
                                                    className: "icon mr-1 h-4 w-4",
                                                    children: /*#__PURE__*/ _jsx("use", {
                                                        xlinkHref: "icons.svg#icon-ETH"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "text-green text-sm font-medium tracking-tight",
                                                children: [
                                                    price,
                                                    " ETH"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "dark:border-jacarta-600 border-jacarta-100 flex w-[22%] items-center border-t py-4 px-4",
                                        role: "cell",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "#",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "text-accent",
                                                children: from
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "dark:border-jacarta-600 border-jacarta-100 flex w-[22%] items-center border-t py-4 px-4",
                                        role: "cell",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "#",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "text-accent",
                                                children: to
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "dark:border-jacarta-600 border-jacarta-100 flex w-[22%] items-center border-t py-4 px-4",
                                        role: "cell",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "#",
                                            children: /*#__PURE__*/ _jsxs("a", {
                                                className: "text-accent flex flex-wrap items-center",
                                                target: "_blank",
                                                rel: "nofollow noopener",
                                                title: "Opens in a new window",
                                                "data-tippy-content": "March 13 2022, 2:32 pm",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mr-1",
                                                        children: date
                                                    }),
                                                    /*#__PURE__*/ _jsxs("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 24 24",
                                                        width: "24",
                                                        height: "24",
                                                        className: "h-4 w-4 fill-current",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("path", {
                                                                fill: "none",
                                                                d: "M0 0h24v24H0z"
                                                            }),
                                                            /*#__PURE__*/ _jsx("path", {
                                                                d: "M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8z"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, id);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var tabs_Activity_tab = ((/* unused pure expression or super */ null && (Activity_tab_Activity_tab)));

// EXTERNAL MODULE: ./node_modules/chart.js/auto/auto.mjs
var auto = __webpack_require__(9217);
;// CONCATENATED MODULE: ./components/tabs/Price_history.jsx




var Price_history_Price_history = function(param) {
    var classes = param.classes;
    return /*#__PURE__*/ _jsx("div", {
        className: "relative mb-24 w-full",
        children: /*#__PURE__*/ _jsx("div", {
            className: "tab-pane fade",
            children: /*#__PURE__*/ _jsxs("div", {
                className: classes,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-10 flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ _jsxs("select", {
                                className: "dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 mr-8 min-w-[12rem] rounded-lg py-3.5 text-sm dark:text-white",
                                children: [
                                    /*#__PURE__*/ _jsx("option", {
                                        defaultValue: "7-days",
                                        children: "Last 7 Days"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        defaultValue: "14-days",
                                        children: "Last 14 Days"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        defaultValue: "30-days",
                                        children: "Last 30 Days"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        defaultValue: "60-days",
                                        children: "Last 60 Days"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        defaultValue: "90-days",
                                        children: "Last 90 Days"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: "last-year",
                                        children: "Last Year"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: "all-time",
                                        children: "All Time"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "py-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "mr-4 inline-block align-middle",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "block text-sm font-bold dark:text-white",
                                                children: "90 Day Avg. Price:"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-green block text-sm font-bold",
                                                children: "\u039E7.0633"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "inline-block align-middle",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "block text-sm font-bold dark:text-white",
                                                children: "90 Day Volume:"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-green block text-sm font-bold",
                                                children: "\u039E24,085.6957"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "chart-container relative h-80 w-full",
                        children: /*#__PURE__*/ _jsx(Bar, {
                            data: {
                                labels: [
                                    "January",
                                    "February",
                                    "March",
                                    "April",
                                    "May",
                                    "June"
                                ],
                                datasets: [
                                    {
                                        type: "line",
                                        label: "Avg. price",
                                        backgroundColor: "#10B981",
                                        borderColor: "#10B981",
                                        data: [
                                            54.73,
                                            64,
                                            53,
                                            96,
                                            130,
                                            100,
                                            102.88
                                        ]
                                    },
                                    {
                                        type: "bar",
                                        label: "Sales",
                                        backgroundColor: "#E7E8EC",
                                        data: [
                                            25,
                                            20,
                                            40,
                                            130,
                                            75,
                                            48,
                                            12
                                        ]
                                    }, 
                                ]
                            },
                            options: {
                                maintainAspectRatio: false,
                                responsive: true,
                                interaction: {
                                    intersect: false,
                                    mode: "index"
                                },
                                scales: {
                                    x: {
                                        grid: {
                                            display: false
                                        }
                                    },
                                    y: {
                                        ticks: {
                                            stepSize: 50
                                        }
                                    }
                                },
                                plugins: {
                                    legend: {
                                        display: false
                                    },
                                    decimation: {
                                        enabled: true
                                    },
                                    tooltip: {
                                        usePointStyle: true,
                                        position: "nearest",
                                        backgroundColor: "#131740",
                                        titleAlign: "center",
                                        bodyAlign: "center",
                                        footerAlign: "center",
                                        padding: 12,
                                        displayColors: false,
                                        yAlign: "bottom"
                                    }
                                },
                                animation: false
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var tabs_Price_history = ((/* unused pure expression or super */ null && (Price_history_Price_history)));

// EXTERNAL MODULE: ./node_modules/react-tabs/style/react-tabs.css
var react_tabs = __webpack_require__(7313);
;// CONCATENATED MODULE: ./components/tabs/Tabs.jsx








var ItemsTabs = function() {
    var ref = useState(1), tabsActive = ref[0], setTabsActive = ref[1];
    var tabsHeadText = [
        {
            id: 1,
            text: "Offers",
            icon: "offers"
        },
        {
            id: 2,
            text: "properties",
            icon: "properties"
        },
        {
            id: 3,
            text: "details",
            icon: "details"
        },
        {
            id: 4,
            text: "activities",
            icon: "activity"
        },
        {
            id: 5,
            text: "price history",
            icon: "price"
        }, 
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "scrollbar-custom mt-14 overflow-x-auto rounded-lg",
            children: /*#__PURE__*/ _jsxs(Tabs, {
                className: "min-w-fit tabs",
                children: [
                    /*#__PURE__*/ _jsx(TabList, {
                        className: "nav nav-tabs flex items-center",
                        children: tabsHeadText.map(function(param) {
                            var id = param.id, text = param.text, icon = param.icon;
                            return /*#__PURE__*/ _jsx(Tab, {
                                className: "nav-item bg-transparent",
                                children: /*#__PURE__*/ _jsxs("button", {
                                    className: tabsActive === id ? "nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white active" : "nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white",
                                    onClick: function() {
                                        return setTabsActive(id);
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("svg", {
                                            className: "icon mr-1 h-5 w-5 fill-current",
                                            children: /*#__PURE__*/ _jsx("use", {
                                                xlinkHref: "/icons.svg#icon-".concat(icon)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "font-display text-base font-medium",
                                            children: text
                                        })
                                    ]
                                })
                            }, id);
                        })
                    }),
                    /*#__PURE__*/ _jsx(TabPanel, {
                        className: "tab-content",
                        children: /*#__PURE__*/ _jsx(OfferTab, {})
                    }),
                    /*#__PURE__*/ _jsx(TabPanel, {
                        children: /*#__PURE__*/ _jsx(Properties, {})
                    }),
                    /*#__PURE__*/ _jsx(TabPanel, {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "tab-pane fade",
                            id: "details",
                            role: "tabpanel",
                            "aria-labelledby": "details-tab",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-t-2lg rounded-b-2lg rounded-tl-none border bg-white p-6 md:p-10",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-2 flex items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "dark:text-jacarta-300 mr-2 min-w-[9rem]",
                                                children: "Contract Address:"
                                            }),
                                            /*#__PURE__*/ _jsx("a", {
                                                href: "#",
                                                className: "text-accent",
                                                children: "0x1cBB182322Aee8ce9F4F1f98d7460173ee30Af1F"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-2 flex items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "dark:text-jacarta-300 mr-2 min-w-[9rem]",
                                                children: "Token ID:"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "js-copy-clipboard text-jacarta-700 cursor-pointer select-none dark:text-white",
                                                "data-tippy-content": "Copy",
                                                children: "7714"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-2 flex items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "dark:text-jacarta-300 mr-2 min-w-[9rem]",
                                                children: "Token Standard:"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-jacarta-700 dark:text-white",
                                                children: "ERC-721"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "dark:text-jacarta-300 mr-2 min-w-[9rem]",
                                                children: "Blockchain:"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-jacarta-700 dark:text-white",
                                                children: "Ethereum"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(TabPanel, {
                        children: /*#__PURE__*/ _jsx(Activity_tab, {})
                    }),
                    /*#__PURE__*/ _jsx(TabPanel, {
                        children: /*#__PURE__*/ _jsx(Price_history, {
                            classes: "dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-t-2lg rounded-b-2lg rounded-tl-none border bg-white p-6"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var tabs_Tabs = ((/* unused pure expression or super */ null && (ItemsTabs)));

;// CONCATENATED MODULE: ./components/component.js














// EXTERNAL MODULE: ./components/Meta.jsx
var Meta = __webpack_require__(3554);
;// CONCATENATED MODULE: ./data/characters_data.js
var characters_data_characters_data = [
    {
        img: "/images/pelgine_1.png",
        id: 1
    },
    {
        title: "Tractor Bowling",
        img: "/images/pelgine_2.png",
        id: 2,
        smallText1: "Ether",
        smallText2: "Airpower",
        icon1: "Frame-2",
        icon2: "Frame-3",
        href: "item_34"
    },
    {
        title: "Rakoun",
        img: "/images/pelgine_3.png",
        id: 3,
        smallText1: "Poison",
        smallText2: "Snow Storm",
        icon1: "Frame-4",
        icon2: "Frame-5",
        href: "item_35"
    },
    {
        title: "Skoopnum",
        img: "/images/pelgine_4.png",
        id: 4,
        smallText1: "Blaze",
        smallText2: "Tornado",
        icon1: "Frame-6",
        icon2: "Frame-7",
        href: "item_36"
    },
    {
        title: "Bumblebee",
        img: "/images/pelgine_5.png",
        id: 5,
        smallText1: "Inferno",
        smallText2: "Water",
        icon1: "Frame-8",
        icon2: "Frame-9",
        href: "item_37"
    },
    {
        title: "Bumblebee",
        img: "/images/pelgine_6.png",
        id: 5,
        smallText1: "Inferno",
        smallText2: "Water",
        icon1: "Frame-8",
        icon2: "Frame-9",
        href: "item_37"
    }, 
];

;// CONCATENATED MODULE: ./components/carousel/characters_carousel.jsx









var characters_carousel_Characters_carousel = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative px-6 pb-16 sm:px-0",
            children: /*#__PURE__*/ _jsx(Swiper, {
                breakpoints: {
                    // when window width is >= 640px
                    100: {
                        // width: 640,
                        slidesPerView: 1
                    },
                    575: {
                        // width: 640,
                        slidesPerView: 3
                    },
                    // when window width is >= 768px
                    992: {
                        // width: 768,
                        slidesPerView: 5
                    }
                },
                effect: "coverflow",
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 5,
                spaceBetween: 30,
                loop: true,
                coverflowEffect: {
                    rotate: 30,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true
                },
                pagination: {
                    clickable: true
                },
                modules: [
                    EffectCoverflow,
                    Pagination,
                    Navigation
                ],
                navigation: {
                    nextEl: ".swiper-button-next-4",
                    prevEl: ".swiper-button-prev-4"
                },
                className: "swiper coverflow-slider !py-5",
                children: characters_data.map(function(item) {
                    var img = item.img, id = item.id, smallText1 = item.smallText1, smallText2 = item.smallText2, title = item.title, icon1 = item.icon1, icon2 = item.icon2, href = item.href;
                    return /*#__PURE__*/ _jsx(SwiperSlide, {
                        children: /*#__PURE__*/ _jsx("article", {
                            children: /*#__PURE__*/ _jsx(Link, {
                                href: "/item/" + href,
                                children: /*#__PURE__*/ _jsx("a", {
                                    className: "animate-gradient--no-text-fill block animate-gradient overflow-hidden rounded-2.5xl !bg-clip-border p-[2px] text-center shadow-md transition-shadow hover:shadow-lg",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "rounded-[1.125rem] bg-jacarta-900 p-8",
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "/images/nft-game/gradient_glow_small.png",
                                                alt: "",
                                                className: "absolute inset-0"
                                            }),
                                            /*#__PURE__*/ _jsx("figure", {
                                                className: "relative my-4 mb-14",
                                                children: /*#__PURE__*/ _jsx(Image, {
                                                    src: img,
                                                    alt: "item 1",
                                                    className: "swiper-lazy inline-block",
                                                    height: "212",
                                                    width: "182"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "relative rounded-2lg bg-jacarta-700 p-5",
                                                children: [
                                                    /*#__PURE__*/ _jsx("h3", {
                                                        className: "mb-3 text-lg font-semibold leading-none text-white",
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex justify-center space-x-5",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "flex items-center",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "mr-2 inline-flex h-7 w-7 items-center justify-center rounded-full bg-jacarta-900",
                                                                        children: /*#__PURE__*/ _jsx("svg", {
                                                                            className: "icon h-6 w-6",
                                                                            children: /*#__PURE__*/ _jsx("use", {
                                                                                xlinkHref: "/icons.svg#icon-".concat(icon1)
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "font-display text-sm font-semibold text-white",
                                                                        children: smallText1
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "flex items-center",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "mr-2 inline-flex h-7 w-7 items-center justify-center rounded-full bg-jacarta-900",
                                                                        children: /*#__PURE__*/ _jsx("svg", {
                                                                            className: "icon h-6 w-6",
                                                                            children: /*#__PURE__*/ _jsx("use", {
                                                                                xlinkHref: "/icons.svg#icon-".concat(icon2)
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "font-display text-sm font-semibold text-white",
                                                                        children: smallText2
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }, id);
                })
            })
        })
    });
};
/* harmony default export */ var characters_carousel = ((/* unused pure expression or super */ null && (characters_carousel_Characters_carousel)));

;// CONCATENATED MODULE: ./components/characters.jsx



var Characters = function() {
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("section", {
            className: "characters-section relative pb-12 pt-24 lg:py-36",
            children: [
                /*#__PURE__*/ _jsx("picture", {
                    className: "pointer-events-none absolute inset-0 -z-10",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/images/gradient_creative.jpg",
                        alt: "gradient",
                        className: "h-full w-full"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "container",
                    children: /*#__PURE__*/ _jsx("h2", {
                        className: "mx-auto mb-16 max-w-md text-center font-display text-3xl text-white",
                        children: "Create High-quality Pixel Art"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "relative px-8 pb-16 sm:px-0",
                    children: /*#__PURE__*/ _jsx(Characters_carousel, {})
                })
            ]
        })
    });
};
/* harmony default export */ var characters = ((/* unused pure expression or super */ null && (Characters)));

;// CONCATENATED MODULE: ./components/promo/statistic.jsx

/* eslint-disable react/no-unescaped-entities */ 

var Statistic = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "relative py-12 lg:py-36",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                    className: "pointer-events-none absolute inset-0 -z-10 after:absolute after:bottom-0 after:h-1/3 after:w-full after:bg-gradient-to-t after:from-[#010107]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/gradient_creative.jpg",
                        alt: "gradient",
                        className: "h-full w-full -scale-y-100"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container -mt-20 lg:pb-32",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mb-12 max-w-5xl font-display text-5xl text-white lg:text-[6rem]",
                            children: "High-quality Pixel Art Assets"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-20 max-w-4xl text-3xl font-medium text-white lg:ml-36",
                            children: "We empower game developers and artists with AI generated Pixel Art. Generate on the website or on Gimp - no GPU required"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-2 gap-8 md:grid-cols-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container pt-32",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "items-center justify-between lg:flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative text-center lg:w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/pelgine_pixelart.png",
                                    alt: "",
                                    loading: "lazy",
                                    className: "relative -top-10 inline-block",
                                    style: {
                                        transform: "scale(1.25)"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:w-[45%] lg:pl-16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "mb-6 font-display text-2xl text-white",
                                        children: "Create High Quality Pixel Art"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-8 text-lg leading-normal text-jacarta-200",
                                        children: "Pelgine will produce beautiful pixel art for your next project fast."
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var statistic = (Statistic);

;// CONCATENATED MODULE: ./data/statistic_promo_2_data.js
var statistic_promo_2_data_statistic_promo_2_data = [
    {
        id: "1",
        img: "/images/pelgine_chars.png"
    }, 
];

;// CONCATENATED MODULE: ./components/carousel/statistic_promo_2_carousel.jsx
















var Statistic_promo_carousel = function() {
    var dispatch = useDispatch();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Swiper, {
                modules: [
                    Navigation,
                    Pagination,
                    Scrollbar
                ],
                spaceBetween: 30,
                slidesPerView: "auto",
                loop: true,
                breakpoints: {
                    240: {
                        slidesPerView: 1
                    }
                },
                navigation: {
                    nextEl: ".bids-swiper-button-next",
                    prevEl: ".bids-swiper-button-prev"
                },
                className: " card-slider-4-columns !py-5",
                children: statistic_promo_2_data.map(function(item) {
                    var id = item.id, img = item.img;
                    return /*#__PURE__*/ _jsx(SwiperSlide, {
                        className: "text-white",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: img,
                            alt: "",
                            width: "398",
                            height: "571",
                            className: "swiper-lazy inline-block border-0"
                        })
                    }, id);
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "group bids-swiper-button-prev swiper-button-prev shadow-white-volume absolute !top-1/2 !-left-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-jacarta-700 text-xl sm:!-left-6 after:hidden",
                children: /*#__PURE__*/ _jsx(MdKeyboardArrowLeft, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "group bids-swiper-button-next swiper-button-next shadow-white-volume absolute !top-1/2 !-right-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-jacarta-700 text-xl sm:!-right-6 after:hidden",
                children: /*#__PURE__*/ _jsx(MdKeyboardArrowRight, {})
            })
        ]
    });
};
/* harmony default export */ var statistic_promo_2_carousel = ((/* unused pure expression or super */ null && (Statistic_promo_carousel)));

;// CONCATENATED MODULE: ./components/promo/statistic_promo_2.jsx

/* eslint-disable react/no-unescaped-entities */ 


var Statistic_promo_2 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "statistic_promo_2-section bg-[#010107] py-12 lg:pb-32 overflow-x-hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container pt-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "items-center justify-between lg:flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative text-center lg:w-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/pelgine_chars.png",
                                alt: "",
                                loading: "lazy",
                                className: "relative -top-10 inline-block",
                                style: {
                                    transform: "scale(1.25)"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:w-[45%] lg:pl-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mb-6 font-display text-2xl text-white",
                                    children: "Bring your game to life with style-consistent characters"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-8 text-lg leading-normal text-jacarta-200",
                                    children: "Choose from a growing variety of styles for characters"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var statistic_promo_2 = (Statistic_promo_2);

;// CONCATENATED MODULE: ./components/promo/statistic_promo_3.jsx

/* eslint-disable react/no-unescaped-entities */ 


var Statistic_promo_3 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "statistic_promo_2-section bg-[#010107] py-12 lg:pb-32 overflow-x-hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container pt-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "items-center justify-between lg:flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative text-center lg:w-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/pelgine_gimp.png",
                                alt: "",
                                loading: "lazy",
                                className: "relative -top-10 inline-block",
                                style: {
                                    transform: "scale(1.25)"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:w-[45%] lg:pl-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mb-6 font-display text-2xl text-white",
                                    children: "Integrate into your favorite art software"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-8 text-lg leading-normal text-jacarta-200",
                                    children: "Pelgine will integrate with a growing list of tools - starting with Gimp"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var statistic_promo_3 = (Statistic_promo_3);

;// CONCATENATED MODULE: ./pages/home/home_1.jsx








var Home_1 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default */.Z, {
                title: "Pelgine | Ai-Generated Pixel Art"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(statistic, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(statistic_promo_2, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(statistic_promo_3, {})
        ]
    });
};
/* harmony default export */ var home_1 = (Home_1);


/***/ })

}]);